export const categoryOptions = [
  {
    label: 'Friends',
    value: 0,
  },
  {
    label: 'Kids',
    value: 1,
  },
  {
    label: 'Family',
    value: 2,
  },
  {
    label: 'Couples',
    value: 3,
  },
  {
    label: 'Boyfriend',
    value: 4,
  },
  {
    label: 'Girlfriend',
    value: 5,
  },
]

export const levelOptions = [
  {
    label: 'Mixed',
    value: 0,
  },
  {
    label: 'Sweet',
    value: 1,
  },
  {
    label: 'Mild',
    value: 2,
  },
  {
    label: 'Spicy',
    value: 3,
  },
]

export const levelColors = {
  1: '#FFD65A', // Sweet
  2: '#FFA600', // Mild
  3: '#E32227', // Spicy
}

// ==================== FRIENDS ====================
const truthFriendsSweet = [
  {
    name: 'What is your favorite memory of our friendship?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'Who is the funniest person in this room?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could travel anywhere in the world right now, where would you go?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite hobby to do on a weekend?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the best compliment you have ever received from a friend?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you won the lottery, what is the first thing you would buy?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What animal do you think you act the most like?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your absolute favorite comfort food?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could have any superpower, what would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is a movie you can watch over and over again without getting bored?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'Who was your very first friend, and are you still in touch?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite holiday of the year?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could change your name to anything, what would you choose?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the best gift a friend has ever given you?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What talent do you wish you had?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could only eat one food for the rest of your life, what would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite season of the year?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'Are you a morning person or a night owl?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the best book or comic you have ever read?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could meet any fictional character, who would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite board game or video game to play with friends?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is something you are really looking forward to this year?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could live in any era of history, which one would you choose?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite dessert of all time?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is a skill you would love to learn?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could instantly speak another language, which one would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite thing about yourself?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What song always puts you in a good mood?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could design a dream theme park, what would the theme be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the best piece of advice a friend has ever given you?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'Would you rather explore space or the deep ocean?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite school subject or topic to learn about?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could be any cartoon character for a day, who would you be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the nicest thing a stranger has ever done for you?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite ice cream flavor?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could build your dream house, what is one crazy room it must have?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite family tradition?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could be an expert at any sport, which sport would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is something that always makes you laugh out loud?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite outdoor activity to do when the weather is nice?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could have any exotic animal as a pet, what would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite pizza topping combination?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the longest time you have ever stayed awake?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could join any famous music band, which one would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite thing to do on a rainy day?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the coolest place you have ever visited?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could switch lives with a celebrity for 24 hours, who would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite joke to tell?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is a funny nickname your friends or family have given you?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could create a new flavor of chips, what would it taste like?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite type of clothing or outfit to wear?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is something you are incredibly proud of accomplishing?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could have dinner with anyone from history, who would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite way to relax after a busy day?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the best breakfast food?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could invent a machine that does one chore, what chore would it do?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite app on your phone right now?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is something you are secretly a big fan of?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could visit any planet in the solar system, which one would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite thing to cook or bake?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the most beautiful place you have ever seen in person?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could star in any TV show, which one would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite color and why?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the most creative thing you have ever made?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could make one rule that everyone in the world had to follow, what would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite sound to hear?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is a movie that always makes you feel happy?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could be the CEO of any company, which company would you choose?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite way to spend time with your best friend?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the best party you have ever attended?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could have a lifetime supply of one snack, what would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite type of weather?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is something you love doing that most people find boring?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could master a musical instrument instantly, which one would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite memory from a past school year?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite quote or saying?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could design your own video game, what would the storyline be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the most interesting fact you know?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite thing to do at an amusement park?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could be the main character in any book, who would you be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite fruit?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is something you are looking forward to doing this weekend?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could have any magical item from a movie, what would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite restaurant to eat at?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the best dream you can remember having?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could change the color of the sky, what color would you pick?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite type of flower or plant?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is something nice you did for a friend recently?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could open your own shop, what would you sell?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite board game of all time?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the most comfortable place in your house?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could name a new star, what would you name it?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite type of exercise or physical activity?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is something you love to collect?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could spend a whole day with an animal, which animal would it be?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite thing about your current age?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is the best compliment you can give to the person on your left?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'If you could create a new holiday, what would we celebrate?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is your favorite thing about this specific friend group?',
    type: 0,
    category: 0,
    level: 1,
  },
  {
    name: 'What is one wish you hope comes true for everyone in this room?',
    type: 0,
    category: 0,
    level: 1,
  },
]
const truthFriendsMild = [
  {
    name: 'What was your exact first impression of me?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever lied to get out of hanging out with someone in this room?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most embarrassing song on your playlist right now?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is a silly habit you have that nobody really knows about?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who is your current secret crush?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever accidentally sent a text about someone to that exact person?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the worst fashion phase you ever went through?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the pettiest reason you have ever broken off a friendship or talking stage?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever cheated on a minor test or quiz at school?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most childish thing you still do?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room do you think is the worst driver or has the worst sense of direction?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever pretended to like a gift from a friend when you actually hated it?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the longest you have gone without showering or brushing your teeth?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever stalked an ex or a crush on social media from a fake account?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing your parents have ever caught you doing?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room would survive the longest in a zombie apocalypse?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever re-gifted something a friend gave you to someone else?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is a food combination you love that other people think is disgusting?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever accidentally walked into a public restroom of the opposite gender?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most embarrassing nickname you have ever had?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who is the most dramatic person in this friend group?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever lied about your age to get into a venue or get a discount?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the dumbest argument you have ever gotten into with a friend?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever fallen asleep in class or during an important meeting?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing you have ever said to a crush?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room is the biggest gossip?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever pretended to be sick to stay home and play video games or watch TV?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the worst haircut or hairstyle you have ever had?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever accidentally broken something at a friend's house and never admitted it?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Who do you think is the biggest teacher's pet or suck-up in your life?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing you have done while trying to look cool?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever snooped through a friend's room or phone when they left it behind?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is your biggest minor pet peeve about the person sitting next to you?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever cried during a movie that wasn't supposed to be sad?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the worst lie you have ever told your parents that they still believe?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room takes the longest time to get ready to go out?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever liked a photo on social media from years ago while stalking someone?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most useless thing you have ever spent your money on?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever waved back at someone who was actually waving at the person behind you?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room is the most likely to get rich but also the most likely to lose it all?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the grossest thing you have ever done when you thought no one was looking?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever ghosted someone because you just didn't want to reply?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is a secret talent you have that is completely useless?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever lied on your resume or a job application?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room is the most likely to get arrested for something silly?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most awkward date you have ever been on?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever blamed a fart on a pet or another person in the room?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the meanest thing you have ever said about a friend behind their back?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever ignored a call from someone in this room on purpose?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is a trend you participated in that you now completely regret?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room is the worst at keeping secrets?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever eaten food out of the trash or off the floor past the 5-second rule?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing that has ever happened to you in public?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever lied to a friend about being busy just because you wanted alone time?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room is the most likely to complain to the manager at a restaurant?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever practice-kissed your pillow or a mirror?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most ridiculous fear or phobia you still have?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever been kicked out of a store, restaurant, or public place?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room do you think has the weirdest taste in music or movies?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever deleted a social media post because it didn't get enough likes?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the worst pickup line you have ever used or had used on you?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever pretended to know a song or a band just to fit in?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who is your biggest celebrity crush that you are slightly embarrassed to admit?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever accidentally ruined a surprise party or a secret event?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most amount of money you have ever lost or misplaced?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever lied about your lifestyle or hobbies to impress a crush?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room do you think is the biggest flirt?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever worn an item of clothing and returned it to the store after?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing you have typed into a search engine?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever had a crush on a friend's sibling?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room has the messiest room or house?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever pretended to look at your phone just to avoid talking to someone?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the worst meal you have ever cooked for someone else?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever been caught talking to yourself out loud?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who do you think is the most stubborn person in this room?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever accidentally laughed at a time when you were supposed to be serious?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most childish argument you have had as an teenager or adult?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever stolen a small item like a pen or candy from a store?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room is the most sensitive person?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever worn the same clothes two days in a row without washing them?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most embarrassing text message you have ever sent to the wrong group chat?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever lied about reading a book or watching a show just to join a conversation?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room is most likely to text their ex after a bad day?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever hidden snacks so you wouldn't have to share them with friends?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the worst advice you have ever given to a friend?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever tripped and fallen in public and pretended it didn't happen?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who do you think has the absolute worst fashion sense in this room?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever used someone else's Netflix, Spotify, or streaming account without asking?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most awkward interaction you have ever had with a neighbor?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever lied about why you were late to a friend's hangout?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who is the biggest screen-time addict in this room?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever fallen out of bed while sleeping?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing you have done while intoxicated or sleep-deprived?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever had a vivid dream about someone in this room that felt weird the next day?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who do you think is the most likely to become a crazy cat or dog person?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: "Have you ever liked a post by accident while snooping through an ex's profile?",
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'What is the most awkward family photo you have ever been a part of?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Have you ever lied to get a free item or discount at a store?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'Who in this room is the biggest lightweight when it comes to staying up late or partying?',
    type: 0,
    category: 0,
    level: 2,
  },
  {
    name: 'If you had to change one thing about the way our group hangs out, what would it be?',
    type: 0,
    category: 0,
    level: 2,
  },
]
const truthFriendsSpicy = [
  {
    name: 'What is a secret you have never told a single person in this room?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever held a major resentment against anyone here without telling them?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the wildest or most chaotic night out you have ever had?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'If you had to cut one person in this room out of your life forever, who would it be?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the biggest romantic regret you currently have?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever broken the law, and if so, what did you do?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most expensive thing you have ever stolen or accidentally taken?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is an opinion you hold that you are too afraid to voice out loud?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: "Have you ever been deeply attracted to a friend's partner or ex?",
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the biggest lie you have ever told to protect your own reputation?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think is the most superficial or fake person?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever regretted becoming close friends with anyone in this room?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most toxic behavior you have ever tolerated from a past friend or partner?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever hooked up with someone and deeply regretted it the next morning?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the closest you have ever come to getting arrested?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you trust the least with sensitive personal information?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever gossiped maliciously about someone in this room to another person here?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the biggest secret you are currently keeping from your family?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever stayed in a relationship or friendship purely because you were lonely?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the meanest thing you have ever done to get revenge on someone?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who do you think is the least successful or least motivated person in this room?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever cheated on a romantic partner, or helped someone else cheat?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most money you have ever lost through gambling, a scam, or a bad investment?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever bad-mouthed a friend’s career, job, or lifestyle choice behind their back?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is something your friends do that makes you feel deeply judged or insecure?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think has the most annoying relationship dynamic with their partner?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever secretly wished failure upon someone you know just out of jealousy?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most controversial or offensive belief you secretly hold?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever used a friend for their money, connections, or car?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most embarrassing medical issue you have ever had to go to the doctor for?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think is trying the hardest to be someone they are not?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever deleted messages or call history to hide something from a partner or friend?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: "What is the most hurtful thing a friend has ever said or done to you that you haven't forgiven?",
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever hooked up with a person you met purely at a random bar or club night?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who do you think in this room will be the first person to get divorced or break up?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever blamed a major mistake at work or university on a completely innocent coworker or peer?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most reckless thing you have ever done while driving or traveling?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever lied to a friend about your financial situation to avoid paying for something?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think has the lowest emotional intelligence?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: "Have you ever intentionally sabotaged someone else's romantic relationship or opportunity?",
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most desperate thing you have ever done to get an ex back?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever had a physical or emotional fight with a friend that ended the friendship for a long time?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who do you think in this room makes the worst life decisions?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: "Have you ever snooped through a partner's personal diary, emails, or texts without permission?",
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the biggest lie you have told on a first date to make yourself look better?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever been banned from a bar, nightclub, or public establishment permanently?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think is the most selfish person in relationships?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever gone to a professional event, work shift, or exam completely hungover or under the influence?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most toxic trait you know you have but refuse to fix?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever hooked up with someone who was already in a committed relationship?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think is the most easily manipulated?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever borrow money from a friend with absolutely no real intention of paying them back on time?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most embarrassing thing you have done due to a massive ego or pride?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: "Have you ever secretly checked a friend's phone notifications when it lit up on the table?",
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who do you think in this room handles stress or emotional crisis the worst?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever lied about a family emergency to avoid a social obligation you hated?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most illegal thing you have ever witnessed a friend do and covered up for them?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever felt completely left out or excluded by this specific friend group?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think has the most boring personality when they are sober?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever kept a gift from an ex that your current partner has no idea about?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most cutthroat or ruthless thing you have done to get a promotion or academic advantage?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever lied to a therapist or counselor because you were too ashamed of the truth?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think has the unhealthiest habits or lifestyle?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: "Have you ever accidentally or intentionally leaked a secret that ruined someone's reputation?",
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is a harsh truth about your own family that you rarely mention to your friends?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever stayed friends with someone purely because they are wealthy or influential?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who do you think in this room is the most defensive when they get called out?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever ghosted an actual close friend instead of having an uncomfortable adult conversation?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most embarrassing reason you have ever been fired from a job or rejected from a position?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever had romantic or sexual thoughts about a person in this room?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who do you think in this room is the biggest hypocrite?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: "Have you ever intentionally ignored a friend's mental health crisis or cry for help because it was too exhausting?",
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most manipulative thing you have ever done to get your own way in a group?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever stolen money from a family member, partner, or close friend?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think is the most likely to betray the group for personal gain?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever felt genuinely happy when a close friend experienced a failure or breakup?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: "What is the most embarrassing thing you have ever done to impress someone who didn't care about you?",
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever lied about your sexual history or dating numbers to avoid being judged?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who do you think in this room has the most unearned privilege?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever broken a promise to a friend that had severe consequences for them?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the deepest insecurity you have about your physical appearance?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever blamed your own bad behavior on a mental health issue or past trauma when you knew better?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think is the least reliable when things get genuinely difficult?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever used dating apps while you were supposed to be in an exclusive relationship?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most embarrassing argument you have ever had with a stranger in public?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: "Have you ever pretended to be happy for a friend's success while secretly hating it?",
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who do you think in this room is the most prone to exaggerating their stories?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever hidden a serious addiction or dangerous habit from the people in this room?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is a secret opinion you have about the partner of someone in this room?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: "Have you ever looked at a friend's bank statement, mail, or pay stub without permission?",
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think is the most materialistic?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever faked an illness, injury, or crisis to gain sympathy or attention from friends?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most desperate thing you have done for money?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever completely lost your temper and physically broken an object during an argument?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who do you think in this room is the most judgmental person?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever let a friend take the fall for a major mistake you made together?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is the most expensive mistake you have ever made at a job?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Have you ever hidden the fact that you went out with other friends from someone in this room?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'Who in this room do you think would be the hardest person to live with as a roommate?',
    type: 0,
    category: 0,
    level: 3,
  },
  {
    name: 'What is a question you are terrified someone is going to ask you during this game?',
    type: 0,
    category: 0,
    level: 3,
  },
]
const dareFriendsSweet = [
  {
    name: 'Give a high-five to everyone in the room.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do 10 jumping jacks right now.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Sing the chorus of your absolute favorite song.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Speak in a British accent for the next two rounds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Balance a spoon on your nose for 10 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Tell the group a corny dad joke.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Give a genuine compliment to the person on your left.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do your best impression of a chicken.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to touch your nose with your tongue.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Show everyone the most wholesome photo on your phone.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do a 15-second plank.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Say the alphabet backward as fast as you can.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Let the person on your right give you a high-five.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Spin around in a circle five times and try to walk in a straight line.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Make up a 10-second rap about the person opposite you.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do your best runway model walk across the room.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Hold a funny face for 20 seconds without laughing.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: "Text a family member just to say 'I love you.'",
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Whisper everything you say for the next round.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to balance on one foot with your eyes closed for 20 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Give a mini motivational speech to the group.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Act like you are swimming across the room.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Name five things in the room that are the color blue in 5 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do a dramatic death scene impression.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend to play an intense guitar solo for 15 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Yawn and see how many people in the room copy you.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Allow someone to draw a small smiley face on your hand with a pen.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do 5 push-ups while counting out loud.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Speak like a robot for the next three turns.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Hum a song until someone guesses what it is.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Stare at the wall and pretend to be deeply inspired by it for 15 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to whistle a popular tune successfully.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are an opera singer and sing your next sentence.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Give the group your best evil laugh.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Act like a cat grooming its paws for 10 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Make up a secret handshake with the person next to you.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do your best impression of a famous cartoon character.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Dance like a robot for 15 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Snap your fingers continuously for the next 30 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to juggling two random objects for 10 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are opening an award show and introducing the next player.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Keep a serious face while the group tries to make you laugh for 15 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Politely ask an inanimate object for permission to use it.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Give a 30-second review of the last movie you watched.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Wear your socks on your hands for the next two rounds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are in a silent black-and-white movie for 1 minute.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do your best impression of a sports commentator calling the game right now.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to puff out your cheeks and look like a pufferfish.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Bow dramatically every time someone says your name for the next round.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Recite a poem or nursery rhyme with extreme passion.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Clap your hands after every sentence you speak for the next round.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend your hands are magnets and keep them stuck together for 2 minutes.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do a slow-motion run across the room.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Make a paper airplane and see how far you can throw it.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to draw a stick figure using your non-dominant hand.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Hold your breath for 15 seconds while smiling warmly.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are a flight attendant giving safety instructions.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Name 10 animals in under 10 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Imitate a monkey eating a banana.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: "Talk to your hand like it's a puppet for 30 seconds.",
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Compliment the first three things you see in the room.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do a simple magic trick or pretend you just did one successfully.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Act like a statue until your next turn.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are walking through deep, sticky mud.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Give a friendly salute to everyone present.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Wink at the end of every sentence you say for the next 2 minutes.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to make yourself cry on cue.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Show off your coolest dance move right now.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you just won the lottery and celebrate accordingly.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Say three nice things about yourself out loud.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to move your ears without using your hands.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Act like a mime trapped in a glass box for 20 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do your best impression of an angry emoji.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to snap with both hands at the same time.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: "List 5 countries starting with the letter 'A'.",
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are a radio DJ introducing a hit song.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Do 10 calf raises right where you are standing.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Laugh hysterically at the next thing anyone says.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are lifting a 500-pound weight.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Give a quick 10-second shout-out to your favorite hobby.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Spell your full name using your chin in the air.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Act like a chef describing a gourmet meal you are cooking.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend to be an alien experiencing gravity for the first time.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Give a gentle high-five to the floor.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Smile as wide as you can for the next 30 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to pat your head and rub your stomach at the same time.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are a newscaster reporting on a fictional weather emergency.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Walk backwards everywhere you go for the next 3 minutes.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Imitate the sound of a roaring lion.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Count down from 20 to 1 as fast as possible.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are a dog waiting for a treat.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: "Say 'boom' every time you finish a sentence for the next round.",
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Show everyone your best martial arts stance.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are a detective investigating a crime scene in the room.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Sing your next three sentences to the tune of Happy Birthday.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Try to balance a water bottle on your head for 15 seconds.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Pretend you are a penguin walking across ice.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Give a thumbs up to everything anyone says for the next 2 minutes.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'Make a funny face and hold it while someone takes a picture.',
    type: 1,
    category: 0,
    level: 1,
  },
  {
    name: 'End your turn by taking a deep, dramatic bow.',
    type: 1,
    category: 0,
    level: 1,
  },
]
const dareFriendsMild = [
  {
    name: 'Let the group style your hair in a ridiculous way and keep it that way for 3 rounds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Text a random emoji to the 5th person in your recent contacts.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Eat a spoonful of a strange food combination chosen by the group (e.g., peanut butter and pickle).',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Call a fast-food restaurant and ask if they sell hot dogs.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone in the group send a text message of their choice to your best friend.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Wear your clothes inside out for the remainder of the game.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Do an impression of the person who initiated this game for 30 seconds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the person on your left draw a fake mustache on your face with a washable marker.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Talk to a houseplant and try to convince it to grow faster for 1 minute.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone scroll through your camera roll for exactly 15 seconds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Sing everything you say for the next two rounds instead of speaking.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: "Call a friend and sing them 'Happy Birthday' even though it isn't their birthday.",
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Post a completely random, out-of-context GIF on your group chat.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Talk without closing your mouth for the next two turns.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone in the group tickle you for 10 seconds without fighting back.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Put an ice cube down your shirt and let it melt completely.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Speak in the third person for the next three rounds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to breakdance on the floor for 15 seconds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone scroll through your most recent Spotify or music search history.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Eat a slice of lemon without pulling a face.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Do your best impression of a crying baby for 20 seconds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the group check your screen time statistics on your phone.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to drink a glass of water without using your hands.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Pretend to be a salesperson trying to sell a piece of trash to the group for 1 minute.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Blindfold yourself and try to guess who is standing in front of you just by touching their shoes.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone use your phone to look at your YouTube search history.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Speak only in whispers for the next 5 minutes.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Walk around the room sideways like a crab for the next two rounds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the group rewrite your status or bio on one social media app for the night.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Ask an AI assistant a highly embarrassing question out loud.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Allow the person to your right to text your crush or partner a single emoji.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Eat a spoonful of hot sauce or mustard.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Imitate the most annoying habit of someone in the room and see if they recognize it.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Keep your hands in your pockets for the next three rounds, no matter what.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the group give you a new nickname that you must answer to for the rest of the game.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Pretend to be a ghost haunting the room for 1 minute.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Send a voice note to a friend making weird animal noises without explaining why.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone brush your teeth or feed you a snack.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Wear a funny hat or item chosen by the group for the rest of the night.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to balance a book on your head while doing 5 squats.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Act like you are a supermodel doing a photoshoot right now.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to wrap yourself completely in toilet paper like a mummy.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: "Let someone look through your phone's note app for 15 seconds.",
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Read the last three text messages you received out loud.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: "Do 20 lunges while repeating 'I love exercise.'",
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Pretend you are an auctioneer and try to auction off your shoes to the group.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone apply a piece of tape to your arm and pull it off quickly.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Bark like a dog every time someone laughs for the next two rounds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to eat a piece of hanging food without using your hands.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Put a funny filter on your face and take a selfie to save to your camera roll.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the group choose a song that you must dance to passionately for 30 seconds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to say a complex tongue twister five times quickly without messing up.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Keep a straight face while someone tries to tickle your feet for 10 seconds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Pretend you are a professional wrestler introducing yourself to the ring.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone look at your most recently used emojis.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Stand in the corner of the room facing the wall until your next turn.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Talk like you have a mouth full of marbles for the next round.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone in the group text a random question to an old classmate.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Pretend to be a mannequin for 1 minute while people try to distract you.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to put on a shirt using only one hand.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Describe your first crush in agonizing detail to the group.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone drop a small amount of cold water onto your forehead.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to make a valid sentence using 10 words that all start with the same letter.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the person on your left redo one of your eyebrows with makeup or a marker.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Do an interpretive dance about how your day went.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Call a friend and tell them you found a mysterious map in your backyard.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Put a sock on your nose and keep it there for the next round.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to eat a snack as slowly as physically possible for 1 minute.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the person opposite you change your phone wallpaper to a picture of their choice.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Pretend you are an alarm clock waking up the entire house.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to keep your eyes open without blinking for 45 seconds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the group look at your food delivery app order history.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Talk while pinching your nose for the next three rounds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Act out a scene from your favorite movie without speaking while the group guesses.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone draw a ring on your finger with a pen.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to do a handstand or cartwheel safely.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: "Pretend you are a server at a fancy restaurant and take everyone's imaginary orders.",
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone look at your email inbox for 10 seconds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Meow like a cat whenever someone addresses you for the next round.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to pick up a pencil from the floor using only your toes.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Give a 1-minute dramatic presentation on why water is wet.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the group check your alarm clock settings on your phone.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Lie flat on the floor and pretend you are a piece of cooked spaghetti.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to put on lip balm without using your hands.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone choose a funny YouTube video that you must recreate accurately.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Hold a cup of water over your head for the next full round.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to type a message to a friend using your nose.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Pretend you are a caveman discovering fire for the first time.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone in the group tickle your palm for 20 seconds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Do your best impression of a siren.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the person to your right whisper a phrase that you must text to a sibling.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to walk around the room with a pillow balanced on your head.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Pretend you are a bodyguard protecting one member of the group for 2 minutes.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let someone look through your online shopping cart.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Attempt to do the moonwalk across the room.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Speak only in rhyming couplets for the next two turns.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Let the group choose a funny filter and take a photo of you.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Try to make a tower out of 5 items in the room in 10 seconds.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: 'Pretend you are a mad scientist explaining your world-domination plan.',
    type: 1,
    category: 0,
    level: 2,
  },
  {
    name: "End your turn by saying 'And that's the tea' in a highly dramatic voice.",
    type: 1,
    category: 0,
    level: 2,
  },
]
const dareFriendsSpicy = [
  {
    name: 'Let the group read the last 5 direct messages you sent on Instagram/Snapchat.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call your crush or an ex and tell them a completely random fact, then hang up immediately.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group post a funny or embarrassing selfie of you on your social media story for 1 hour.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Hand over your phone unlocked to the group for 1 minute to check any app they want.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a random number and try to stay on the line for 1 minute without hanging up.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the person on your right send any text message they want to your crush or partner.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Show the group the most embarrassing photo or video currently saved on your phone.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone in the group look through your entire internet search history from the past week.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a family member and tell them you are getting a massive, ridiculous face tattoo.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group look through your blocked contacts list and explain why you blocked them.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Text an old friend you haven't spoken to in over a year and say 'I know what you did.'",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone write a post on your Facebook or Twitter account and leave it up for 24 hours.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Do a prank call to a local store asking if they have a lost penguin in their lost-and-found.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group see your most recent bank or online purchase transaction.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a friend outside the room and tell them you are deeply in love with an inanimate object.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the person on your left go through your direct messages on your primary messaging app.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Reveal the most embarrassing secret you've kept from your parents out loud.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let the group choose someone from your contacts list for you to send a voice note saying 'I miss you.'",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Show the group your camera roll's 'Recently Deleted' folder.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a restaurant and try to reserve a table for a party of 50 people for tonight.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group choose a song, and you must sing it loudly out the window or door.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Show everyone the last text exchange you had with your crush, partner, or ex.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone in the group go through your photo gallery for 30 seconds uninterrupted.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a friend and try to convince them that you are moving to another country next week.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group choose an embarrassing profile picture for you to keep on WhatsApp/Discord for 24 hours.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Reveal who in this room you would be most reluctant to be stranded on a desert island with.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone text your boss, supervisor, or teacher a completely random but polite question.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Call a random contact on your phone and whisper 'The package is secure' before hanging up.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group look through your saved posts or bookmarks on any social media app.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Recreate your most embarrassing public moment using the people in the room as actors.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let someone text a random contact from your phone: 'Can I borrow $100? No questions asked.'",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Show the group your most cringeworthy childhood photo or video.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call your parents and calmly tell them you accidentally dyed your hair neon green.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group scroll through your archived or hidden chats on any messaging app.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Perform a passionate love poem dedicated to an object in the room chosen by the group.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone look through your notes app specifically for any diaries, rants, or secrets.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a friend and try to sell them your current shoes for $500, staying in character for 1 minute.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group look at your saved passwords or autofill usernames (without revealing sensitive keys).',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Post a video of yourself doing a silly dance to your social media story right now.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the person opposite you text anyone in your phone list a single question mark.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Show your worst driver's license, passport, or ID photo to the entire group.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a local business and dramatically read them a piece of poetry.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone look at your most recent screen recording or video captures.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Reveal the biggest lie you've ever told to get out of trouble with your friends.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group choose a random contact for you to call and pretend you meant to call someone else.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Show the group your email spam folder or trash folder to see what's inside.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let the person on your right send a text to your third most recent contact saying 'I'm watching you.'",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a random pizza place and try to order a burger and fries, acting genuinely confused.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group see your Tinder/dating app profile and swiping history, if applicable.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Reveal the most embarrassing nickname you have ever been given by an ex or crush.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone look at your calendar app to see your private reminders and notes.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a contact chosen by the group and tell them they have a beautiful voice, then hang up.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group write a funny review on a local business page using your real name account.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Show the group your most embarrassing playlist or music phase history.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone read your last 3 sent emails out loud to the group.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a sibling or close relative and pretend you forgot your own name for 30 seconds.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group send an obscure inside joke to one of your professional or school contacts.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Reveal an unpopular opinion you hold that would genuinely upset your closest friends.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let someone check your phone's notification log to see what you cleared recently.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a friend and try to convince them that you have just won an Olympic medal.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let the group change your phone language to a language you don't speak for the next hour.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Show the group your most embarrassing online forum post or comment from the past.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let the person on your left text your parents: 'I have some news.' and wait 1 minute before clarifying.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a hotel and ask if they have a special room specifically designed for vampires.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group choose an old photo on your Instagram or Facebook to delete permanently.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Reveal the pettiest reason you have ever stopped talking to someone.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone text your best friend a message saying that you are quitting your job or school.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a random contact and sing the entire chorus of a Disney song to them.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group choose a message from your direct message history to read aloud with dramatic flair.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Show the group your most private or hidden Pinterest board or saved item list.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a friend and speak completely in gibberish, trying to act like nothing is wrong.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone look through your app store purchase or download history.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Reveal a secret habit you have when you are completely alone in your house.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let the person opposite you text your crush/partner: 'What's your favorite thing about me?'",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a local gym and ask if they have a workout program specifically for training to fight aliens.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group look at your most recent clipboard copies on your phone.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Show the group the last photo you took that you decided *not* to post online because it was too weird.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let someone text a random contact from your phone: 'I know your secret.'",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a friend outside the room and try to whisper-convince them that your house is haunted right now.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Reveal the most embarrassing mistake you have ever made at work or school.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group choose an emoji that you must append to every single message you send for the next 24 hours.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Show the group your most heavily edited selfie next to the unedited original version.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone look through your voice memos or audio recordings.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Call a family member and ask them for permission to change your legal name to 'Spiderman.'",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let the group look at your phone's storage settings to see which apps use the most space.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Reveal who in the group you would trust the least with a massive secret.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let someone text your second most recent contact: 'We need to talk.'",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a local pet store and ask if they have any talking rocks for sale.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group check your screen time data for your most embarrassing app.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Reveal a time you accidentally saw something you weren't supposed to see.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone scroll through your saved memes or reaction images for 30 seconds.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Call a friend and try to maintain a conversation while pretending to be asleep or snoring.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let the group draft a bizarre tweet or post for your account that stays up for 30 minutes.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Show the group your oldest saved text messages on your phone.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone send an encrypted message of emojis to your crush without any text explanation.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Reveal the most childish thing you still do on a regular basis.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Let the group choose a contact for you to call and casually ask 'Are you mad at me?'",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: "Show the group your phone's default maps app search history.",
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'Let someone in the group change your ringtone to an embarrassing sound for the next 24 hours.',
    type: 1,
    category: 0,
    level: 3,
  },
  {
    name: 'End your turn by revealing your ultimate, most guarded guilty pleasure song.',
    type: 1,
    category: 0,
    level: 3,
  },
]

// ==================== COUPLES ====================
const truthCouplesSweet = [
  {
    name: 'What was your exact first impression of me when we met?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite memory of our first date together?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'When did you first realize that you had feelings for me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a small, everyday habit of mine that secretly makes you smile?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If we could book a plane ticket to anywhere in the world right now, where would we go?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite physical feature of mine?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What song always makes you think about our relationship?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the most romantic thing you think I have ever done for you?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If our love story was a movie title, what would it be called?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: "What is a silly nickname you would love to call me but haven't yet?",
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What outfit of mine is your absolute favorite to see me wear?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is one thing about our future together that you look forward to the most?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What emoji do you use the most when you are texting me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite way to spend a lazy Sunday morning with me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If you could recreate any date we have ever had, which one would it be?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a talent or skill of mine that you secretly admire?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the best piece of relationship advice you have ever heard?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'How do you feel when we are apart for a few days?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the funniest inside joke that only the two of us share?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a hobby you would love for us to try learning together?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite photo of us together and why do you love it?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What scent or smell always reminds you of me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the nicest compliment you have ever received from me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If you had to describe our relationship in just three words, what would they be?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite habit that we have formed as a couple?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a dream you had about me that you still remember?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite way to be comforted by me when you are sad?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If we won the lottery tomorrow, what is the first thing we would buy together?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is something new you learned about me in the past month?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite meal that we have cooked or eaten together?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a small thing I do that makes you feel incredibly safe?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If we could live in any fictional world or TV show universe, which one would you pick?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the best gift I have ever given to you?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a random thought you had about me earlier today?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite time of day to spend time with me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If you could buy me any dream car tomorrow, what would you choose for me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a silly fear you have that you only feel comfortable sharing with me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the most adventurous thing you want us to do together this year?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite way for us to show affection in public?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What personality trait of mine do you wish you had a little more of?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: "What is a hidden talent of yours that you haven't fully shown me yet?",
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite text message you have ever received from me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If our relationship had a theme song, what would it be?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is something you always look forward to doing with me on weekends?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: "What is your favorite childhood memory that you haven't told me yet?",
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the most beautiful place you have ever seen with your own eyes?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If you could change the name of our pet (or future pet), what would you name it?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a small gesture of love that you appreciate more than a big gift?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite season of the year to experience as a couple?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What made you fall in love with me in the first place?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is one thing you are incredibly proud of us for achieving together?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If we could open a small business together, what kind of shop would it be?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite way to hold hands or cuddle with me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a book or movie that you think perfectly describes our vibe?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is something you always want to tell me but sometimes forget to say?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite memory of us with our friends or family?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the most creative date idea you have been secretly planning for us?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a personality quirk of mine that you find surprisingly cute?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If we were characters in a cartoon, who do you think we would be?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the best breakfast you have ever had with me in bed?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is one thing about me that always manages to calm you down?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite childhood tradition that you want to bring into our future?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a tourist spot you have always wanted to visit specifically with me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the most thoughtful thing you think a partner can do?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite memory of a trip or vacation we took together?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a song that always makes you want to dance with me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: "What is one thing you bought recently that you can't wait to show me?",
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite type of weather to cuddle up with me in?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the most meaningful promise you want to make to me today?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a secret dream you have for our home or living space one day?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the best part about coming home to me at the end of a long day?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a funny face or expression I make that you love the most?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite memory of a holiday we celebrated together?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If you could describe my laugh in one word, what would it be?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a question you have been meaning to ask me all week?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is something you always boast or brag about me to your friends?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite physical touch from me when you are feeling stressed?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a food you hated before but enjoy now because of me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the most fun night out we have ever had together?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a sweet habit you hope we never lose as we grow older?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite memory of a rainy day spent together?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is one word that instantly brings a smile to your face when I say it?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a creative hobby you think I would be really good at doing?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite memory of our early messaging or texting days?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is something you always look forward to eating when we go out?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the most comforting thing I have ever said to you?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'If you could write a short poem about us, what would the first line be?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite way to wake up next to me in the morning?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a small goal you want us to accomplish together next month?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the most romantic view you have ever shared with me?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a secret talent of mine that you think deserves more recognition?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is your favorite outfit that I have ever worn on a special night?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is something about our communication that you think is really strong?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a funny meme that instantly reminds you of our relationship?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: "What is your absolute favorite way to hear me say 'I love you'?",
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a movie we watched together that you could rewatch a hundred times?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the best piece of advice you think we have given each other?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a small physical gesture I do that makes your heart race a little?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is a future milestone for us that you are most excited to celebrate?',
    type: 0,
    category: 3,
    level: 1,
  },
  {
    name: 'What is the single happiest moment you have experienced with me so far?',
    type: 0,
    category: 3,
    level: 1,
  },
]
const truthCouplesMild = [
  {
    name: 'What is my most annoying habit that you secretly wish I would stop doing?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever pretended to like a movie or TV show just because I liked it?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the silliest or most petty thing we have ever had an argument about?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever secretly looked at my phone screen while I was texting someone?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing that has happened to you while we were together?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a fashion choice of mine that you secretly think looks terrible?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever eaten the last piece of food and blamed it on someone else or a pet?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a text message of mine that you completely misunderstood at first?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever lied about liking a meal that I cooked for you?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Which of my friends or family members were you most nervous to meet for the first time?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is something I do in public that makes you feel a little embarrassed?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "Have you ever pretended to be asleep just so you wouldn't have to talk or do a chore?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the worst or most awkward date we have ever gone on together?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever secretly re-gifted something that I gave to you?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a habit of mine in the bathroom or kitchen that drives you crazy?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'If you could delete one item from my wardrobe without me knowing, what would it be?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever been secretly jealous of a casual interaction I had with someone else?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the longest amount of time you have gone without showering around me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a song I love to sing along to that you absolutely cannot stand hearing?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever lied to get out of spending time with my friends or family?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most useless thing I have ever bought that you wish I would throw away?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Who is the better driver between the two of us, and be completely honest?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "What is a secret purchase you made recently that you haven't told me about yet?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "Have you ever snooped through my room, drawers, or closet when I wasn't around?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most embarrassing nickname your parents or childhood friends have for you?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever pretended to be sick just to get extra attention or pampering from me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a chore or task around the house that you always try to sneakily avoid?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever cleared your browser history specifically because of something embarrassing?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the worst haircut or hairstyle you have ever had since we started dating?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever agreed with me out loud while completely disagreeing in your head?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a habit of yours that you tried hard to hide from me when we first started dating?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'If you had to rate my snoring or sleeping habits on a scale of 1 to 10, what would it be?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "Have you ever checked my social media profile from a friend's phone or a fake account?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most childish thing you still do when you are frustrated or upset?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever accidentally sent a text meant for me to someone else entirely?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a movie genre you absolutely hate but watch anyway just to make me happy?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever taken credit for a chore or cleanup job that I actually did?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most awkward compliment you have ever tried to give me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever been embarrassed by how much money you spent on something silly?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is an internal rule of mine that you secretly think is totally ridiculous?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever accidentally broken something of mine and never admitted to it?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most awkward encounter we have ever had with one of your exes?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever checked my location using a sharing app without a real reason?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a food combination that I eat which you find absolutely disgusting?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever lied about how long it would take you to get ready for a date?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing your parents have ever said about you in front of me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever pretended to know a fact or a word I used just to look smart?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "What is something you borrowed from me weeks ago and still haven't returned?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever been secretly annoyed by how long I take to choose a movie or meal?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most ridiculous excuse you have ever used to get out of a date with me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "Have you ever hidden a snack or a treat so you wouldn't have to share it with me?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a phrase or slang word I use that makes you cringe inside every time?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "Have you ever double-checked my math or a fact I told you because you didn't believe me?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the messiest room or area you have ever let our living space get into?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever worn an item of my clothing without asking and put it back dirty?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a reality TV show or cheesy media piece you watch that you are embarrassed to admit?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever pretended to be busy just to have some alone time away from me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most awkward photo of me that you have saved on your phone?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever forgotten an important date or anniversary in our relationship?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the silliest superstition or irrational fear that you still believe in?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever disagreed with my taste in music but smiled and nodded anyway?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a habit of mine when eating or chewing that makes you want to cover your ears?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "Have you ever taken a sip of my drink or a bite of my food when I wasn't looking?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most awkward conversation you have ever had with my parents?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever looked up an ex on social media just to see what they are doing now?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a bad habit you have that you are actively trying to hide from me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever lied about liking a specific hairstyle or clothing item on me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the longest you have ever spent overthinking a single text message I sent?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever pretended to love an activity or sport just to impress me early on?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most embarrassing song on your current favorite playlist?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever been jealous of a celebrity or fictional character that I find attractive?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "What is a chore that I do that you always end up secretly re-doing because it wasn't right?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever blamed a weird smell in the room on a pet or something else instead of yourself?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most awkward text message you have ever received from a member of my family?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever snooped through my trash or recycling out of pure curiosity?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a secret habit you have when you are completely alone in the house?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever exaggerated a story or an achievement just to make yourself look cooler to me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing you have ever dropped down the toilet or sink?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever secretly wished I would change out of an outfit before we left the house?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most awkward silence we have ever shared in our relationship?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever lied about your opinion on a piece of home decor or furniture I bought?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a funny habit I have when I am deep in thought or concentrating?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever forgotten the name of someone I introduced you to immediately?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing you have done while trying to be romantic?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "Have you ever pretended to understand a joke I made when you actually didn't get it?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a specific habit of mine that makes you realize I am getting stressed out?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever lied about your budget or how much money you had for a date?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the silliest thing you have ever gotten competitive about with me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: "Have you ever worn a dirty piece of clothing because you didn't want to do laundry?",
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most embarrassing app you currently have installed on your phone?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever hidden a minor mistake you made at work or school from me?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a bad habit of mine that you think you have accidentally started doing too?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever felt awkward about the way we hold hands or show affection in public?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most ridiculous rumor you have ever heard about yourself or someone else?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever lied about how much you enjoyed a specific vacation or trip we took?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing you have ever blurted out during a quiet moment?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever secretly looked at my phone notifications when they popped up on the screen?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is a minor detail about our first meeting that you completely forgot until recently?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'Have you ever felt a little insecure about a specific talent or skill that I have?',
    type: 0,
    category: 3,
    level: 2,
  },
  {
    name: 'What is the absolute funniest face I make when I am completely caught off guard?',
    type: 0,
    category: 3,
    level: 2,
  },
]
const truthCouplesSpicy = [
  {
    name: 'What is your ultimate, most intense fantasy that you have been too hesitant to share with me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever thought about an ex-partner while we were being intimate together?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a deep secret about your past dating history that you have never told anyone else?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the biggest lie or omission you have ever told me since we started our relationship?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt a strong attraction to one of my close friends or acquaintances?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is your absolute favorite part of our intimacy, and what is one thing you want to change?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever regretted getting into a serious relationship with me, even for a brief moment?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the wildest, most adventurous location where you have ever wanted to be intimate with me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever kept a secret about your finances, debts, or spending habits from me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a boundary of yours that you feel I have crossed but you never brought it up?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: "Have you ever checked up on a recent ex-partner's relationship status out of pure curiosity?",
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most physically or emotionally vulnerable you have ever felt while with me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever stayed in this relationship during a rough patch simply because you feared being alone?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a habit or trait of your ex that you sometimes wish I possessed?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What was the exact moment in our relationship where you felt the most distant or disconnected from me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: "Have you ever deleted a text conversation or a direct message thread specifically so I wouldn't see it?",
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most dramatic or chaotic fight you have ever had in a past relationship?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'If you could ask an ex-partner one question with a guarantee of an honest answer, what would it be?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever faked or exaggerated your enthusiasm or satisfaction during intimacy with me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a deep personal insecurity about your body or appearance that you still hide from me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever flirted with someone else online or in person while we were officially together?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is something your friends know about your romantic life that you have hidden from me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most illegal or highly risky thing you have ever done in your life?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt that my family or background is a major red flag for our long-term future?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a secret desire or preference of yours that you worry might make me judge you?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever developed a crush on a coworker or colleague while dating me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the biggest sacrifice you feel you have made in order to keep this relationship going?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: "Have you ever compared our relationship to a friend's relationship and felt like we were failing?",
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a specific comment or criticism I made in the past that deeply hurt your feelings?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever had a dream about being with someone else and felt guilty about it afterward?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the absolute longest you have gone feeling genuinely angry or resentful toward me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever snooped through my old journals, emails, or personal items to find out about my past?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a part of your single life or past freedom that you deeply miss the most?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever lied to your friends or family members to cover up a mistake I made?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most embarrassing romantic or sexual mishap you have ever experienced in your life?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever kept a piece of memorabilia, a photo, or a gift from an ex hidden away somewhere?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is one thing about my lifestyle or personal goals that you secretly worry is incompatible with yours?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like you were losing your own personal identity inside of our relationship?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a secret truth about your mental health or emotional state that you have been holding back?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever intentionally tried to make me feel jealous or insecure to see how I would react?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most physically intense or memorable dream you have ever had about me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like you are putting significantly more effort into this relationship than I am?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is an opinion or belief of mine that you completely disagree with but choose not to debate?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever had a gut feeling or intuition that we might not last forever as a couple?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the absolute closest you have ever come to cheating on a partner in your past?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever hidden a significant health issue, habit, or medical concern from me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most sensitive topic for you that you feel we constantly talk around instead of addressing?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt genuinely unappreciated or ignored by me for a long period of time?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a secret vice, addiction, or bad habit that you have managed to keep hidden from me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever lied about your level of experience or your past partners when we first met?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is something you wish I would do more often in the bedroom without you having to ask?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt judged by me regarding your career path, income, or personal ambitions?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most chaotic or wild night out you have ever had before you met me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever been tempted to break up with me over a specific habit or recurring issue?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a secret fear you have about how our relationship might change over the next five years?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever hidden a major failure or mistake at work or school because you feared my reaction?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: "What is the most vulnerable secret you have shared with a best friend but still haven't told me?",
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like you have to change your natural personality or act differently around me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a physical trait or habit of mine that you initially found to be a major turn-off?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt uncomfortable with the amount of contact I keep with an ex or a specific friend?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most intense romantic heartbreak you have ever experienced before our relationship?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like I am too emotionally dependent or independent for your liking?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is an intimacy preference of yours that you have tried with someone else but never with me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever lied about where you were going or who you were meeting up with?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the biggest regret you have regarding the way you treated a partner in a past relationship?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like my friends do not genuinely like or respect you as my partner?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a specific topic or memory from your childhood that you still find too painful to share?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like our relationship has fallen into a boring or predictable routine?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most shallow reason you have ever had for breaking up with someone in your past?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like you are compromising too much of your own happiness for mine?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a specific fantasy or scenario you think about when you want to get into the mood?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever hidden a minor crush you had on a mutual friend of ours?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: "What is the most intense argument we have ever had that you still don't feel fully resolved about?",
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt a sudden flash of panic about the level of commitment in our relationship?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a hidden part of your personality that you only reveal when you are completely alone?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: "Have you ever felt like I don't truly understand or validate your emotional needs?",
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most rebellious or reckless thing you have ever done to impress someone else?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever lied to me about your true feelings regarding a major life decision we made?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a habit of mine that makes you feel a little less romantically attracted to me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like you are holding back your true potential because of this relationship?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most explicit or scandalous text message you have ever sent or received?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like my personal insecurities are negatively impacting your mental health?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a secret about your family dynamic or history that you are deeply protective of?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like we rushed into certain milestones or stages of our relationship too quickly?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most critical thought you have ever had about my parenting, future parenting, or life skills?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like you have to walk on eggshells around me when I am in a bad mood?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is an intimacy-related insecurity you have developed since we started dating?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: "Have you ever kept a secret piece of good news from me because you didn't want to overshadow me?",
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most challenging obstacle you think we will have to overcome as a couple?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like you love me more than I love you, or vice versa?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a deep, dark fear about getting older that you have never spoken out loud to me?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt genuinely let down or abandoned by me during a time of personal crisis?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most controversial opinion you hold that you know I would completely disagree with?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever looked at my old social media posts from years ago to judge my past self?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a secret habit you have for coping with stress that you know I would worry about?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever felt like our relationship is holding you back from traveling or exploring the world?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most intimate or deep conversation we have ever had, and why did it impact you?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'Have you ever lied to me about your true satisfaction with our current living arrangement?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is a part of my personality that you find the most difficult to love or accept?',
    type: 0,
    category: 3,
    level: 3,
  },
  {
    name: 'What is the most profound and honest truth you can tell me about how you feel about me right now?',
    type: 0,
    category: 3,
    level: 3,
  },
]
const dareCouplesSweet = [
  {
    name: 'Give your partner a 30-second back massage.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Whisper the nicest thing you can think of into your partner's ear.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Slow dance with your partner for one minute with no music playing.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Stare into your partner's eyes for 30 seconds without smiling or laughing.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner three genuine, unique compliments right now.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Write a quick, 2-line love poem for your partner and read it aloud.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Kiss your partner on the forehead and hold it for 5 seconds.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Hold your partner's hand for the next 10 minutes of the game.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner style your hair however they want for the next round.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Sing a 30-second snippet of your partner's favorite song.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a long, warm hug that lasts at least 20 seconds.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner your absolute favorite memory of when you first started dating.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner use your lap as a pillow for the next 5 minutes.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss on both cheeks and the tip of their nose.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Recreate your very first kiss with your partner right now.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Take a cute, silly selfie together and save it as your phone wallpaper for 24 hours.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Do your best impression of your partner's laugh.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tickle your partner for 10 seconds straight.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner feed you a bite of a snack or a sip of a drink.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Describe your partner using only three words.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a piggyback ride around the room.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Serenade your partner with a goofy love song using a fake microphone.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Trace a word on your partner's back with your finger and make them guess what it is.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner the exact moment you realized you had feelings for them.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Make a funny face at your partner and try to make them laugh.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a gentle foot rub for one minute.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Pinky swear to do one nice chore for your partner tomorrow.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner pick your outfit for tomorrow.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Do a 15-second celebratory dance for having such a great partner.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner which of their physical features makes you smile the most.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Speak in a formal British accent for the next 3 rounds when talking to your partner.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Kiss your partner's hand like royalty.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Compliment your partner's outfit in an over-the-top, dramatic fashion.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner give you a temporary tattoo using a washable marker.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Gently brush or comb your partner's hair.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'List five things you are incredibly grateful for in your relationship.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Blink rapidly at your partner like a cute cartoon character.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Put your arm around your partner and don't take it off for 15 minutes.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner a cheesy pickup line with complete seriousness.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Feed your partner a piece of fruit or chocolate as dramatically as possible.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Show your partner the last photo you took of them on your phone and explain why you love it.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a high-five, then a low-five, then a warm hug.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner rest their feet in your lap.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Whisper a sweet secret to your partner that you haven't told anyone else.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Do a funny walk across the room to make your partner smile.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Gently pinch your partner's cheeks and tell them they are cute.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner which movie character they remind you of the most.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Make a paper airplane and write a tiny love note on the wing, then throw it to them.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Hold your partner's face in your hands for 15 seconds.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner what your dream vacation together would look like.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner tickle your feet for 5 seconds.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a bear hug from behind.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Hum your relationship's 'theme song' and see if your partner can guess it.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Make up a secret handshake with your partner right now.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner what their best habit is.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner take a photo of you making a goofy face.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Name three things your partner does that always make you feel safe.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss on the wrist.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Tell your partner a funny story from your childhood that they haven't heard.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Do a silly runway walk across the room, ending with a wink at your partner.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a 30-second shoulder massage.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Look at your partner and try not to blink for 15 seconds.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Say 'I love you' in the most high-pitched voice you can manage.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Draw a tiny heart on your partner's palm with a pen.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner your favorite thing about their personality.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Wrap a blanket around both of you and cuddle closely for 3 minutes.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a kiss on the chin.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner a riddle and give them a kiss if they guess it right.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Share your favorite dream you've ever had about your partner.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Do 5 jumping jacks while loudly proclaiming your love for your partner.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner choose a nickname for you that you have to answer to all night.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Gently trace your partner's jawline with your index finger.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner which song always reminds you of them.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Make a funny dynamic duo pose with your partner.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a gentle head massage.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Tell your partner what you think your life would look like if you hadn't met.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Keep your eyes locked with your partner's while you take a drink of water.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a warm embrace and lift them slightly off the ground if possible.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Tell your partner a joke, and if they don't laugh, you have to give them a kiss.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Lean your head on your partner's shoulder for the next 5 minutes.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner the best piece of advice they have ever given you.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a gentle kiss on the back of their neck.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Hold your partner's hand and swing your arms playfully for 30 seconds.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Describe the perfect date night with your partner from start to finish.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner give you a big bear hug for as long as they want.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner the top three things that make them completely unique.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss on the collarbone.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Nuzzle your nose against your partner's neck for 10 seconds.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner your favorite outfit that they wear.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Write 'I love you' on a piece of paper using your non-dominant hand and give it to them.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Praise your partner's cooking or another skill they take pride in.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Wink at your partner every time they look at you for the next 10 minutes.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a soft kiss on their closed eyelids.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner what you look forward to most about growing old together.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a gentle squeeze on the arm and a warm smile.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Describe your partner's eyes using poetic vocabulary.",
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Let your partner lean against your back for 2 minutes.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Tell your partner how they have helped you become a better person.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: 'Give your partner a kiss on the palm of their hand.',
    type: 1,
    category: 3,
    level: 1,
  },
  {
    name: "Whisper 'You are my favorite person' to your partner right now.",
    type: 1,
    category: 3,
    level: 1,
  },
]
const dareCouplesMild = [
  {
    name: 'Let your partner look through your recent search history for 1 minute.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Allow your partner to send a single text of their choice to anyone in your contacts.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Put on a blindfold and try to guess 3 objects your partner places in your hands.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Do your best impression of your partner when they are angry or annoyed.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner do your makeup using only 3 products, blindly.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Talk like a baby for the next 3 rounds of the game.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner read one random archived chat on your messaging apps.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Post a silly, unedited picture of yourself on your social media story right now.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Call a mutual friend and tell them an absurd, fake rumor about your partner.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner scroll through your phone gallery for 60 seconds.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Wear your clothes inside out for the remainder of the game.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Try to fit as many marshmallows or grapes in your mouth as you can, then say your partner's name.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner whisper a dare into your ear that you *must* do, keeping it secret from others.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Imitate your partner's morning routine in an exaggerated way.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner draw a funny mustache on your face with an eyebrow pencil.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Give your partner your phone and let them reply to your last 3 unread notifications.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Dance like a robot for 1 minute straight without breaking character.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Let your partner read your last three notes in your phone's Notes app.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Call a fast-food place and try to order something that is clearly on a competitor's menu.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner tickle you for 30 seconds while you try to stay completely silent.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Eat a spoonful of a condiment chosen by your partner (e.g., hot sauce, mustard).',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Imitate the first argument you two ever had, but make it incredibly dramatic.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Let your partner change your phone's ringtone to a sound of their choice.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner read your horoscope aloud while you react to it dramatically.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Do your best impression of your partner's mother or father.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Wear your partner's shoes for the next 10 minutes.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner put a piece of ice down your back.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Try to spin around 10 times and then walk in a straight line to kiss your partner.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner write a goofy status update and post it to your profile.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Speak only in whispers for the next 3 turns.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner check your screen time breakdown for the past week.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Recreate a famous romantic movie scene with your partner, but poorly.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner pick a song that you have to lipsync to with maximum passion.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Do 15 push-ups, and if you can't, let your partner sit on your back while you try one.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Give your partner your unlocked phone and let them delete one app of their choice.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner put an item of their clothing on you.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Act like a dog begging for food from your partner for 30 seconds.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner look at your oldest profile pictures on social media.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Try to make your partner laugh by telling them a story using only gibberish.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner blindfold you and feed you a mystery item from the fridge.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Allow your partner to change your contact name in their phone to something embarrassing.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Balance an open bottle of water on your head for 1 minute while talking to your partner.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner look through your liked videos on TikTok, YouTube, or Instagram.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Do your best impression of a cheesy soap opera actor professing love to your partner.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner give you a wet ويلى (wet-willy) or a light pinch.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Sing everything you want to say for the next 5 minutes.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner check your Amazon, shopping cart, or wish list.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Do a dramatic death scene while crying out your partner's name.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner style your eyebrows in a weird way using gel or tape.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Speak like a pirate until it is your turn again.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner read your most embarrassing old text messages from years ago.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Attempt to do a handstand or a cartwheel in front of your partner.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner paint one of your fingernails with a bright color.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Act like your partner's personal butler/maid for the next 10 minutes.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner see the oldest photo currently stored on your phone.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Keep a straight face while your partner makes the funniest faces possible for 30 seconds.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner check your email inbox for any spam or funny subscriptions.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Plank for 45 seconds while staring directly into your partner's eyes.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner wear your favorite jacket or shirt for the rest of the night.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Propose to an inanimate object in the room with absolute sincerity.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner see your blocked users list on any app.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Try to hula hoop or dance with an imaginary hoop for 1 minute.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner speak for you during the next round of the game.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Imitate how your partner acts when they are sleepy.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner put a funny sticker anywhere on your face.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Recite the alphabet backward as fast as you can; kiss your partner every time you make a mistake.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner look at your most used emojis and judge them.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Stand in the corner of the room for 2 minutes and pretend you are a statue.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner mimic your worst habit while you watch.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Try to touch your nose with your tongue; if you fail, let your partner tickle your ribs.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner see your food delivery app order history.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Serenade your partner using only animal noises (e.g., meows, barks).',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner braid your hair or create a silly hairstyle.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Walk backward everywhere you go for the next 5 minutes.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner see who you search for most frequently on Instagram or Facebook.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Hold a spoonful of water in your mouth while your partner tries to make you laugh.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner choose an accent that you must use for the next 2 rounds.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Perform a 30-second stand-up comedy routine about your relationship quirks.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Let your partner check your phone's battery usage breakdown.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Put a piece of clothing on your head and wear it like a hat for 10 minutes.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner scroll through your hidden or deleted photo album.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Prank call a close friend and try to keep them on the line for 1 minute without laughing.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner give you a nickname that you must use on social media for a day.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Do your best impression of how your partner drives.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner look at your bookmarked or saved posts on social media.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Balance on one foot for the next 2 minutes while carrying out a conversation.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner text your sibling or a friend a funny, random emoji.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Act like a tour guide and give a grand tour of the room you are currently in.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner check your spotify or apple music wrapped / recent history.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Pretend to be a waiter/waitress and take your partner's order with an attitude.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner apply a piece of tape to your face and pull it off gently.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Do 20 squats while repeating 'My partner is the best' on every single repetition.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner see your calendar or schedule for the upcoming week.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Speak only in rhymes for the next three turns.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner look at your cloud storage or drive files for 1 minute.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Give your partner a dramatic, funny 1-minute speech on why they should vote for you as 'Best Partner'.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner look through your wallet or purse entirely.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: "Try to cry on command within 1 minute; if you can't, give your partner a back rub.",
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Let your partner draw a tiny face on your stomach or arm using a pen.',
    type: 1,
    category: 3,
    level: 2,
  },
  {
    name: 'Agree to everything your partner says or asks for the next 5 minutes.',
    type: 1,
    category: 3,
    level: 2,
  },
]
const dareCouplesSpicy = [
  {
    name: 'Give your partner a slow, passionate kiss on the lips that lasts for at least 30 seconds.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Whisper your most scandalous or intimate fantasy into your partner's ear in detail.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Gently bite your partner's earlobe, then whisper something teasing.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner feed you an item of food directly from their own mouth.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Take off one article of clothing of your partner's choosing.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a deep, romantic kiss on the neck, leaving a lingering trace.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Sit on your partner's lap for the next three rounds of the game.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Trace your lips along your partner's jawline down to their collarbone.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner put their hands under your shirt and leave them there for 1 minute.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner an intense, lingering kiss wherever they want it most.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Whisper a detailed description of what you want to do to your partner later tonight.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Blindfold yourself and let your partner kiss you anywhere they choose; you must guess where.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner slowly unbutton or unzip one part of your clothing.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Use your lips to trace a slow line from your partner's wrist all the way up to their shoulder.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a sensual 3-minute full-body or back massage with your shirt off.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner whisper an incredibly bold, intimate dare that you must perform right now.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Kiss your partner's stomach gently and hold them close.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Remove an article of clothing using only your teeth.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner trace their fingers along your inner thigh for 30 seconds.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss while holding their hands pinned above their head.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Tell your partner exactly what physical attribute turns you on the most about them.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner choose an article of clothing for you to remove right now.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Kiss your partner's neck until they can't help but gasp or chuckle.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Sit face-to-face with your partner, legs intertwined, and hold a deep gaze for 1 minute.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Send a highly suggestive, teasing selfie to your partner right now, even though they are in the room.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner give you a massage using their favorite scented lotion or oil.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Gently run your fingers through your partner's hair while kissing them deeply.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Tell your partner the wildest dream you've ever had involving them.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner breathe softly against your neck for 30 seconds without moving.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Kiss your partner starting from their forehead, moving down to their lips, neck, and chest.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner whisper a dirty joke or phrase into your ear using their most attractive voice.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Keep your hands on your partner's waist or hips for the next 15 minutes of the game.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss that gets more intense with every passing 10 seconds.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner use their lips to trace the outline of your jaw.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Describe the absolute hottest moment you think you two have ever shared.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner blindfold you and guide your hand over different parts of their body.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Take off two articles of clothing right now.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a slow, gentle kiss on their inner wrist.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Tell your partner your favorite time or place where you two got intimate.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner trace a line down your spine with a single piece of ice.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Kiss your partner while sitting completely in their lap.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Whisper an intimate secret about yourself that you've never shared with anyone else.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner bite your lip gently during a kiss.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Run your hands slowly down your partner's back and press your bodies together tightly.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Describe in vivid detail what your partner is wearing in your favorite memory of them.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner kiss your bare shoulders for 1 minute.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a deep kiss without using your hands at all.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Tell your partner a physical boundary you want to push or explore with them in the future.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner place their bare feet on yours while you slow dance intensely.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Kiss your partner's collarbone repeatedly for 30 seconds.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Show your partner your favorite physical asset on your own body and explain why you like it.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner kiss you while you are leaning back over the edge of the couch or bed.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Whisper a naughty word or phrase to your partner three times in a row.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner trace their fingers lightly over your lips.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a lingering kiss on the back of their knee or inner thigh.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Describe exactly what turns you on about the way your partner smells.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner take off one of your socks using only their teeth.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Kiss your partner passionately while running your hands through their hair.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Tell your partner what type of lingerie or clothing you find most attractive on them.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner hold you closely from behind while whispering sweet, teasing things.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a soft, slow kiss on the tip of their tongue.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Describe your ideal romantic morning after a night of deep intimacy.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner trace your collarbone with a ice cube.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a long kiss on the cheek, transitioning slowly to their lips.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Tell your partner the one thing they do in bed that drives you absolutely crazy.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner unbutton your shirt halfway.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Kiss your partner's hand, moving slowly up their arm to their neck.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a passionate 10-second kiss every time someone says a specific word for the next hour.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner place a kiss anywhere on your torso.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Describe the first time you felt an intense physical attraction to your partner.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner gently pull your hair while giving you a deep kiss.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Take off your socks using only your feet, then rub your feet against your partner's.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a soft kiss on their lower back.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Tell your partner a secret thought you had about them the very first day you met.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner rest their head on your bare chest for 2 minutes.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a deep kiss while gently holding their chin.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Describe an intimate scenario you want to recreate from a movie or book.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner run their fingers along your ribs and stomach.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a slow kiss on their temple, jaw, and then lips.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Tell your partner what physical gesture makes you feel the most loved and desired.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner kiss your palms and fingers slowly.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a warm, tight hug while lifting them up and pressing against them.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Describe how your heart rate changes when your partner gets close to you.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner trace their lips along your neck without actually kissing it.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a deep, romantic kiss that leaves you both completely breathless.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Tell your partner what nickname you secretly find incredibly attractive when they use it.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner kiss your bare back for 1 minute straight.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a playful, gentle bite on the shoulder or arm.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: "Describe your partner's lips using three highly descriptive words.",
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner pull you close by your belt loops or waistline.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a soft kiss on the bridge of their nose, then a passionate one on the lips.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Tell your partner a text message you wanted to send them before but felt too shy to.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner slide their hand down your back and hold you close for a full minute.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss while blindfolded.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Describe the exact outfit your partner wears that makes you want to kiss them instantly.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner place their hands anywhere they want on your body for 30 seconds.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a lingering kiss on the side of their neck, right below the ear.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Tell your partner what part of their body you think is the most underrated.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Let your partner kiss you anywhere they want for 45 seconds straight.',
    type: 1,
    category: 3,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss right now to officially close out the game.',
    type: 1,
    category: 3,
    level: 3,
  },
]

// ==================== KIDS ====================
const truthKidsSweet = [
  {
    name: 'What is your absolute favorite dessert of all time?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could have any animal as a pet, what would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best gift you have ever received?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'Who is your favorite superhero and why?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could have one superpower, what would you choose?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite subject or activity at school?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the funniest joke you know by heart?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could only eat one food for the rest of your life, what is it?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite Disney or animated movie?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'Who is your best friend and what do you like most about them?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could build a house out of anything, what would you use?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite thing to do on a rainy day?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could visit any place in the world, where would you go?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite video game or board game?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the happiest memory you have?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If your favorite toy could talk, what would it say?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite season of the year and why?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best dream you can remember having?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could invent a new holiday, what would it celebrate?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite cartoon character?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the coolest thing you know how to do?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could rename yourself, what name would you pick?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite book or bedtime story?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best topping to put on a pizza?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could be an animal for one day, which one would you be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite ice cream flavor?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is something that always makes you laugh?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'Who is the funniest person in your family?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite song to sing or dance to?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could change the color of the sky, what color would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite sport to play or watch?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best compliment someone has ever given you?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could open a store, what would you sell?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite thing to do at the playground?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could meet any fictional character, who would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite holiday tradition?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the prettiest thing you have ever seen?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you found a genie lamp, what would your three wishes be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite candy?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best thing about being the age you are right now?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could grow anything on a tree, what would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite animal sound to imitate?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the most fun vacation you have ever taken?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could design a new amusement park ride, what would it look like?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite flavor of juice or soda?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is something you are really good at doing?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could stay up as late as you wanted, what would you do?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite cereal?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: "Who is your favorite teacher you've ever had?",
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could create a new color, what would you name it?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite thing about your bedroom?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best thing your mom or dad cooks?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could talk to trees, what do you think they would tell you?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite farm animal?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best hiding spot you know for hide-and-seek?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could be a character in any video game, who would you be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite dinosaur?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the most exciting thing that happened to you this week?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could live in a castle, a treehouse, or a spaceship, which would you choose?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite fruit?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best piece of advice a friend has ever given you?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could make one rule that everyone in the world had to follow, what would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite type of weather?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best drawing or craft you have ever made?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could have a robot assistant, what chores would it do for you?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite family memory?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the coolest animal you have ever seen at the zoo?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could talk to sea creatures, what would you ask a shark?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite thing to do on your birthday?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: "What is your favorite stuffed animal's name?",
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could magically learn any language instantly, what would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite thing to do with your siblings or cousins?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the most beautiful sound in nature?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could be the mayor of your town for a day, what would you do?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite breakfast food?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best movie snack?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could turn any chore into a game, which one would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite insect or bug?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the most comfortable clothing item you own?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could spend a whole day with a celebrity, who would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite type of flower?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the nicest thing you did for someone recently?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could live under the sea, what kind of house would you build?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite thing to watch on YouTube or TV?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best sound in the world?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could instantly become an expert at a musical instrument, which one would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite thing about your school?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the best surprise you have ever had?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could visit outer space, which planet would you check out first?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite vegetable (if you had to pick one)?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite hobby outside of school?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could spend a day with any historical figure, who would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite thing to do when you wake up?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the coolest rock or shell you have ever found?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could make a giant sculpture out of LEGO, what would it be?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite color to wear?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the most interesting fact you know?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'If you could run a zoo, which animal would be the main attraction?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is your favorite weekend activity?',
    type: 0,
    category: 1,
    level: 1,
  },
  {
    name: 'What is the absolute best thing about your life right now?',
    type: 0,
    category: 1,
    level: 1,
  },
]
const truthKidsMild = [
  {
    name: 'Have you ever pretended to be sick to stay home from school?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the weirdest food combination that you actually enjoy?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever blamed a sibling or a pet for something you did?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the scariest movie or TV show you have ever watched?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever accidentally dropped food on the floor and ate it anyway?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a rule your parents have that you think is completely unfair?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever hidden a bad test score or report card from your parents?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most annoying habit that one of your friends has?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever pretended to like a gift when you actually hated it?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the silliest thing you are afraid of?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever stayed up past your bedtime reading or playing on a screen?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing that has happened to you at school?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever cheated while playing a board game or video game?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a word that you always have trouble pronouncing?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever worn your clothes inside out or backwards without realizing it?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the longest you have ever gone without washing your hands or showering?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever cried during a movie? If so, which one?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is something you used to believe when you were younger that is totally silly?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "Have you ever accidentally called a teacher 'Mom' or 'Dad'?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the grossest thing you have ever touched?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever talked to yourself in the mirror?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a food that you absolutely refuse to eat?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever broken something in the house and hidden the pieces?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Who is your secret favorite person in your family?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever fallen out of bed while sleeping?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most childish toy or blanket you still keep in your room?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "Have you ever tried to cut your own hair or your doll's hair?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most boring book you have ever been forced to read?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "Have you ever snuck a snack when you weren't supposed to?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What chore do you absolutely hate doing the most?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever forgotten your homework and blamed it on something else?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the weirdest dream you can remember having?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever made a mess and walked away like nothing happened?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a song that you love but feel a little embarrassed to admit?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "Have you ever tried to look through your parents' closet for hidden gifts?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the worst haircut you have ever had?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "Have you ever pretended to understand something a friend said when you didn't?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is something you are secretly jealous of a friend for having?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever fallen down in public in a really clumsy way?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most annoying sound in the world to you?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever gotten your head or finger stuck in something?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a lie you told that you got caught in immediately?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever argued with a friend over something completely silly?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "What is the longest time you've spent playing video games in one day?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever lost a library book or a school book?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most embarrassing nickname your parents call you?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever practiced making funny faces in a reflection?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a fashion trend you think looks completely ridiculous?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "Have you ever forgotten a close friend's birthday?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is something you do when you are nervous?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever peed in a swimming pool?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most trouble you have ever gotten into at school?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "Have you ever looked at someone else's test answers by accident?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the worst smell you have ever encountered?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever pretended to clean your room by just shoving everything under the bed?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a commercial or jingle that always gets stuck in your head?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever stayed in your pajamas for a whole weekend?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most useless superpower you can think of?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever been scared of the dark or needed a nightlight?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a game you play that you think you are the absolute best at?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever accidentally broken a toy belonging to a friend?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most annoying thing your brother or sister does?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever cried because of a lost video game match?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most food you have ever eaten in one sitting?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever pretended to know how to do something when you were totally lost?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the weirdest thing you collect?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever forgotten to brush your teeth before going to school?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a movie you secretly like but your friends think is bad?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "Have you ever eavesdropped on your parents' conversation?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the funniest face you can make right now?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever spilled something on your clothes right before leaving the house?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "What is a talent you wish you had but don't?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever made up a fake rule during a game just to win?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "What is the most boring trip or errand you've ever had to go on?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever accidentally sent a text or message to the wrong person?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is something you always forget to do?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever gotten lost in a store for a few minutes?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most ridiculous excuse you have ever given a teacher?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever giggled at a time when you were supposed to be completely quiet?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a bad habit you are trying to stop doing?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "Have you ever pretended to be asleep so someone wouldn't bother you?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the worst grade you have ever gotten?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever worn mismatched shoes or socks to school?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is something that always makes you grumpy?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever deleted a game in anger because it was too hard?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most money you have ever found on the ground?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever lied about your age to get into something or play a game?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a food you used to hate but now you actually like?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever dropped your phone or a tablet on your face while lying down?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "What is the most embarrassing thing you've said out loud without thinking?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "Have you ever copied a friend's style or outfit?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: "What is the longest you've gone without brushing your hair?",
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever been caught talking to yourself?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is a word or phrase you use way too much?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever gotten stuck at the top of a slide or a climbing wall?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the most boring chore your parents make you do?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever been scared by a bug that turned out to be fake?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is something you always misplace or lose?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'Have you ever pretended to like a food just to be polite?',
    type: 0,
    category: 1,
    level: 2,
  },
  {
    name: 'What is the one thing you are most looking forward to doing when you are older?',
    type: 0,
    category: 1,
    level: 2,
  },
]
const truthKidsSpicy = [
  {
    name: 'Who is your biggest secret school crush right now?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the biggest lie you have ever told your parents without getting caught?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever taken something that didn't belong to you, even if it was small?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "What is your biggest, deepest fear that you haven't told anyone?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever said something mean behind a good friend's back?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most embarrassing thing your parents have ever caught you doing?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever read someone else's diary, private notes, or texts?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'If you had to pick one person in this room to leave on a deserted island, who would it be?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is a secret about yourself that absolutely nobody else knows?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever blamed a friend for something you did just to avoid getting grounded?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the meanest thing you have ever said to a sibling or classmate?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever pretended to be friends with someone just because they had cool toys or games?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the biggest mistake you have ever made that you still feel bad about?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever let someone else take the blame for a mess you made?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'If you could replace one of your friends with a celebrity, who would go?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is something your parents do that completely embarrasses you in front of friends?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever snooped through your teacher's desk when they weren't looking?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most trouble you have ever been in at home?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever uninvited someone from a party or hangout because of what others thought?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is something you are incredibly self-conscious or worried about?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever lied about doing your homework when you didn't even start it?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Who do you think is the least favorite person in your current friend group?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever made up a rumor about someone else at school?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "What is the most embarrassing thing you have ever done to get a crush's attention?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever eaten something out of the trash can?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'If you could change one thing about your physical appearance, what would it be?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever broken a major house rule when your parents left you alone?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Who is the one person in this room that you secretly disagree with the most?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever pretended to be sick just to avoid taking a specific school test?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is a secret someone told you that you accidentally shared with someone else?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever felt jealous of your best friend's accomplishments?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most childish habit you still have that you hide from friends?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever lied to a friend to avoid hanging out with them?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most awkward conversation you have ever had with your parents?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever cried because you were frustrated with a teacher or coach?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the worst lie you have ever told to get yourself out of a sticky situation?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever felt like your parents favor a sibling over you?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is something you did that you are genuinely ashamed of?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever cheated on a school test or quiz?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "If you had to delete one friend's social media or gaming profile forever, whose would it be?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever ignored a friend's message on purpose because you didn't want to talk?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the meanest prank you have ever played on someone?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever dropped your toothbrush in the toilet or on the floor and still used it?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is something you secretly do when you think you are completely alone in your room?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever lied about your skills or achievements to impress someone?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Who is the most annoying teacher you have right now, and what do they do?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever broken an expensive item and never confessed to it?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most embarrassing thing you have ever worn in public?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever had a crush on a friend's sibling?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is a rule your parents have that you secretly break all the time?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever been caught talking about someone right when they walked into the room?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most stubborn you have ever been during an argument?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever pretended to like a book or movie just to fit in with a group?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most embarrassing song playlist on your device right now?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever lied to your parents about how much money you spent?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Who do you think is the funniest person in this room, and who is the least funny?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever been grounded? What was the reason?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most awkward thing you have ever accidentally said to a teacher?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever hidden dirty dishes or clothes just so you wouldn't have to clean them?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever lied about liking a friend's outfit or haircut to keep them happy?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is something you are secretly terrified of growing up and facing?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever gotten in trouble for using bad words when your parents weren't around?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the longest you have gone without washing your favorite blanket or jacket?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever thrown away a lunch your parents made because you didn't like it?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Who in this room do you think would be the first to crack under a lie detector test?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever faked a signature or an initial on a school form?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is a secret obsession you have that you think people would judge you for?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever been caught eating something in bed that left a massive mess?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever pretended to know a popular song or trend when you had no clue?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most ridiculous thing you have ever cried over?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever deleted a text message thread so your parents wouldn't see it?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Who do you think is the biggest troublemaker in your class?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever purposely made a game harder for someone else just because you were losing?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most embarrassing thing you have done while trying to be cool?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever hidden a pet's toy or treat just to tease them?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the biggest secret you are keeping from your siblings?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever lied about being finished with your chores when you weren't?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most awkward photo of you that exists on the internet or a phone?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever pretended to be a different person online or in a game chat?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is something you said that completely ruined a surprise party or gift?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever been caught staying up past midnight on a school night?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most embarrassing phase or trend you used to be obsessed with?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever lost something important and blamed it on someone else?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most awkward thing that has ever happened to you during a school presentation?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever snuck out of your room after you were supposed to be asleep?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Who is a friend you used to be close with but secretly can't stand anymore?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the biggest overreaction you have ever had to a minor problem?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever pretended to lose your voice or be hurt to get out of gym class?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the grossest habit you have that you only do when no one is watching?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever hidden food you didn't want to finish behind a couch or under furniture?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "What is a secret thought you've had about the person sitting to your left?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever lied about having an allergy just because you hated a food?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "What is the most embarrassing thing you've ever done at a sleepover?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: "Have you ever used your parents' credit card or account to buy something without asking?",
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the meanest thing you have ever done to an animal or bug?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever gotten so mad during a board game that you flipped the board or quit?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the most embarrassing thing you have ever said to a crush?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'Have you ever lied on a truth question during a previous game of Truth or Dare?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'What is the one secret you hope your parents never, ever find out about you?',
    type: 0,
    category: 1,
    level: 3,
  },
  {
    name: 'If you had to switch lives with someone in this room for a week, who would it be and why?',
    type: 0,
    category: 1,
    level: 3,
  },
]
const dareKidsSweet = [
  {
    name: 'Do your best impression of a roaring lion.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Spin around in a circle five times and try to walk in a straight line.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Balance a book on your head and walk across the room without it falling.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Hop on one foot while counting backward from 10.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Speak in a high-pitched robot voice for the next two rounds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Give someone in the room a big, enthusiastic high-five.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do 10 jumping jacks as fast as you can.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Try to touch your tongue to the tip of your nose.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Act like a monkey looking for a banana for 30 seconds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Sing your favorite song in a funny opera voice.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Wiggle your ears or eyebrows without using your hands.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do a silly dance in the center of the room with no music.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are walking on a tightrope across the floor.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Say three nice things about the person sitting to your right.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Make a funny face and hold it for 20 seconds while everyone tries to make you laugh.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a superhero flying through the sky for one minute.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do a slow-motion run from one side of the room to the other.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Try to blink your eyes 30 times in 10 seconds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Act like a penguin walking on ice.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Give a compliment to every single person in the room.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend your arms are noodles and shake them all around.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Meow like a cat until it's your turn again.",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Try to balance on one foot for a full 45 seconds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Make the sound of a roaring race car engines for 15 seconds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you just won a massive trophy and give a thank-you speech.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Draw a picture of a smiley face using only your non-dominant hand.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do your best impression of a chicken laying an egg.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Whisper everything you say for the next two rounds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Pretend you are a statue and don't move a muscle for 30 seconds.",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Talk like a pirate for the next three minutes ('Ahoy, mateys!').",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Try to clap your hands behind your back five times.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are an astronaut floating around in zero gravity.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Make up a 10-second song about your favorite food and sing it loud.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do five lunges while keeping a big smile on your face.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Act like a puppy trying to catch its own tail.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a frozen ice cube melting slowly under the sun.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Wave to a random object in the room and say, 'Good morning, friend!'",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Snap your fingers ten times (or try your best to do it).',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Stand up and do your absolute best runway model walk.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a frog and hop across the room three times.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pat your head while rubbing your tummy at the same time.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Make a sad face, then a happy face, then a scared face in quick succession.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Spell your first and last name out loud backward.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a tree blowing violently in a big storm.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do a silent laugh—make the face and body movements but no sound.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are an airplane taking off and landing.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Act like a crab walking sideways for 20 seconds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Try to tell a joke without laughing at all while telling it.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Air-guitar like a rock star to an imaginary song for 30 seconds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are eating a giant, messy sandwich with your hands.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do your best impression of a buzzing bumblebee looking for flowers.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Give yourself a giant hug and say, 'I am awesome!'",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Try to whistle a simple tune like 'Happy Birthday.'",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are walking through deep, sticky mud.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Draw an imaginary picture in the air and make everyone guess what it is.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Act like a baby dinosaur hatching out of an egg.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Hold a funny pose until another player claps their hands.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Pretend you are a clock and make 'tick-tock' sounds with your tongue.",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do 5 giant star jumps.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Bark like a happy dog whenever anyone says your name for the next round.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a magician and show off a fake magic trick.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Try to touch your toes without bending your knees.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Act like an elephant using its trunk to drink water.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Say the alphabet as fast as you can in under 10 seconds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a kangaroo hopping all over the room.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Make a funny noise with your mouth that you've never made before.",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Bow deeply like a prince or princess meeting royalty.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are an alarm clock going off early in the morning.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Try to balance an eraser or small toy on your knee for 20 seconds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Smile as wide as you can for the next full minute.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a snake slithering across a smooth floor.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Draw a star on a piece of paper using your toes holding the marker.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Act like a turtle moving in ultra-slow motion.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are an Olympic weightlifter lifting an incredibly heavy bar.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Sing the chorus of your favorite song completely from memory.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a fish blowing bubbles underwater.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do your best impression of a scary monster sound.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Try to look at your nose with both eyes at the same time.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a cowboy riding a bouncy horse.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Make up a secret handshake with the person closest to you.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a giant giant taking huge, heavy steps around the room.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Giggle uncontrollably for 15 seconds for absolutely no reason.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a mime stuck inside a small glass box.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Act like a sleepy bear waking up from a very long winter nap.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Yawn loudly and try to make someone else in the room yawn too.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a chef tossing a giant pizza dough in the air.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do your best impression of a squeaking mouse.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Try to walk backward around the room without bumping into anything.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a wind-up toy that runs out of battery and stops.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Make a heart shape with your hands and point it at someone.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Act like a seal flapping its flippers and making barking sounds.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a detective examining a mysterious footprint on the floor.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Do 3 slow, deep superhero breaths to power up your energy.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Pretend you are an owl spinning its head around and saying 'hoot hoot.'",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Make a funny face at a wall and try to make the wall laugh.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a duck waddling down to a pond.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Hug a stuffed animal or a pillow like it's your best friend.",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Pretend you are a popcorn kernel popping in a hot pan.',
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: "Stand on one foot and spell out the word 'DARE' in the air with your other foot.",
    type: 1,
    category: 1,
    level: 1,
  },
  {
    name: 'Give a giant, dramatic bow to your audience.',
    type: 1,
    category: 1,
    level: 1,
  },
]
const dareKidsMild = [
  {
    name: 'Let another player style your hair into the silliest look possible.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Eat a slice of lemon or a tiny bit of lime without making a sour face.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Put your socks on your hands and wear them like that for the next three rounds.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone draw a tiny, funny mustache on your face with a washable marker.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Talk like you have a mouth full of marbles for the next two minutes.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Wear your shirt completely inside out for the rest of the game.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Drink a small glass of water without using your hands at all.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Sing everything you want to say instead of talking for the next two rounds.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let another player gently tickle your feet for 10 seconds without you kicking.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to stack 5 random objects on top of each other without the tower falling.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Do your best impression of a teacher giving a strict lecture.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Wear a funny hat or an extra piece of clothing chosen by the group until the game ends.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to rhyme every word you say for the next full minute.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Stare at the person across from you for 30 seconds without blinking once.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone wrap you up like a human burrito using a blanket.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Eat a small bite of food (like a cracker) off a plate using only your mouth.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Do your best impression of one of your family members or friends in the room.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: "Keep your hands on your hips and don't take them off for the next two rounds.",
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Talk in an accent (like British, pirate, or cowboy) for the next three minutes.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone put a funny sticker right on your forehead.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to spin a coin on the table and catch it before it stops.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are an infomercial host trying to sell a plain old shoe.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Do 15 squats while singing the alphabet song.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone give you a crazy new nickname that everyone must use for the rest of the day.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a cat and try to drink water from a small bowl on the floor.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Balance a spoon on your nose for at least 10 seconds.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Draw a quick portrait of the person sitting next to you in under 30 seconds.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: "Quack like a duck every time someone says the word 'the' for the next round.",
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Walk backward into the kitchen or another room and bring back an object.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let another player paint one of your fingernails with a crazy color.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to keep a balloon or a soft crumpled paper ball in the air using only your head.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Put a piece of clothing on backward (like your jacket or sweater).',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a slow-motion kung fu master practicing your moves.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Dip a chip or a cracker into a weird combination (like ketchup on a sweet cookie) and take a bite.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Do your absolute best operatic scream into a pillow.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone put a funny pair of sunglasses on you upside down.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to guess who a player is just by feeling their hands while your eyes are closed.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Do a funny dance move while holding a glass of water without spilling a drop.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Speak only in whispers for the next three rounds of the game.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a statue and let the group pose your arms and legs into a silly shape.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to write your name on a piece of paper using your chin or your elbow.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: "Stand in the corner of the room and talk to the wall like it's your principal.",
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone write a silly word on your arm with a washable pen.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Walk around the room with a pillow balanced perfectly on your head.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a crying baby who lost their pacifier for 20 seconds.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to say a tricky tongue twister three times fast without messing up.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Give a 30-second dramatic speech about why homework should be completely banned.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let another player choose a song for you to lip-sync to with maximum passion.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a wet dog shaking water off your fur all over the room.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to pick up a pencil from the floor using only your toes.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Keep a totally serious face while the rest of the group tries their best to make you laugh.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Put your shoes on the wrong feet and walk around the room twice.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: "Pretend you are an alien who just landed on Earth and doesn't know what a chair is.",
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone do a silly makeover on you using hair clips or rubber bands.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: "Act like a sheep that forgot how to 'baa' and makes weird noises instead.",
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Eat a spoonful of yogurt or applesauce with your eyes completely closed.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to juggle two soft objects (like socks) for 15 seconds.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Act out a scene from your favorite movie using a super high voice.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone tie your shoelaces together, then try to take three steps safely.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a robot whose batteries are running low and speak slower and slower.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to count from 1 to 20 but skip every number that has a 3 in it.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let another player draw a funny cartoon face on the palm of your hand.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Act like a commercial actor who is deeply in love with a piece of broccoli.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Keep one eye closed for the next two rounds of the game.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to balance a water bottle on the back of your hand for 15 seconds.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a news reporter breaking a story about a missing teddy bear.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let the person to your left gently style your eyebrows into a funny shape.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: "Hop like a bunny while shouting 'Happy Easter!' even if it's not Easter.",
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to say your entire name with your tongue sticking all the way out.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone put an ice cube in your hand and hold it until it fully melts or for 30 seconds.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are an opera singer singing a tragic song about a dropped ice cream cone.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Walk like a crab while carrying a small stuffed animal on your tummy.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: "Let someone tape a sign to your back that says 'Silly Goose' for the next two rounds.",
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to whistle while keeping your mouth as wide open as possible.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a turkey running away right before Thanksgiving.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Do 10 push-ups (knee push-ups are totally fine!).',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let another player blindfold you and try to guess what snack they feed you.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Act like an angry bird whose nest was moved.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to do a perfect cartwheel or a funny roll on a soft carpet.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: "Speak only in questions for the next two minutes (e.g., 'Is it my turn? Why?').",
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a security guard protecting a highly valuable piece of trash.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone spray your hair with a little bit of water and style it up.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to lick your elbow (it’s nearly impossible, but give it a good try!).',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Act like a parrot repeating the last word of every sentence someone else says.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Balance a small book on your foot while lifting it off the ground for 10 seconds.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are an old grandpa or grandma looking for lost reading glasses.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let the group choose a silly word that you have to say at the end of every sentence.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: "Try to do the 'floss' dance move or another popular dance as fast as possible.",
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a professional wrestler introducing yourself to the crowd.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone trace a funny shape on your back and try to guess what it is.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: "Act like a monkey who just realized they don't like bananas anymore.",
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to spell the longest word you know completely out loud.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a block of ice melting super fast in a microwave.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone put a pair of clean socks onto your ears like floppy dog ears.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to tell a funny story using only animal noises and gestures.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Walk on your knees around the entire room one full time.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Pretend you are a vacuum cleaner making loud noises and cleaning the floor.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Let someone else choose a silly hat for you to wear backward for 3 rounds.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Try to bounce a soft ball on your knee three times in a row.',
    type: 1,
    category: 1,
    level: 2,
  },
  {
    name: 'Strike a dramatic bodybuilder pose and hold it for a full 30 seconds.',
    type: 1,
    category: 1,
    level: 2,
  },
]
const dareKidsSpicy = [
  {
    name: "Go to the front door or window, open it, and yell 'I love peanut butter!' at the top of your lungs.",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group give you a complete, wild, washable marker facial makeover.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Call a family member (like a grandparent or aunt/uncle) and sing 'Happy Birthday' to them, even if it's not their birthday.",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Eat a small teaspoon of hot sauce, mustard, or horseradish straight.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone dump a small cup of cold water over your hands or feet.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Do your worst, most embarrassing dance move in front of everyone for a full minute.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Let another player text a funny, silly message to one of your parents using your phone or an adult's phone.",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Wear your socks on your hands and your shoes on your hands for the next round.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group style your hair using crazy gel, water, or clips, and leave it like that for the rest of the day.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Pretend you are a chicken and 'lay an egg' (a ball or toy) in the middle of the room while making loud clucking noises.",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone mix a tiny bit of two safe drinks together (like juice and milk) and drink a sip of it.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Go outside or into the hallway and do the chicken dance for two full minutes.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let another player write a funny word right on your cheek with a washable marker.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Pretend you are a dog and beg someone in the room for a treat or cracker.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Give a 2-minute passionate speech about why you should be the absolute ruler of the entire world.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group completely blindfold you and try to walk across the room guided only by their voices.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Try to eat a piece of fruit or a cookie hanging from a string without using your hands.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Speak in a heavy, dramatic Shakespearean theatrical voice for the rest of the game.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone put an ice cube down the back of your shirt for 10 seconds.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Act like a dramatic villain who just had their evil master plan totally ruined.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Go up to a parent or adult, stare at them seriously, and say, 'The platypus flies at midnight,' then walk away.",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group wrap your legs together with plastic wrap or a scarf and try to hop around a chair.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Eat a piece of raw onion or a tiny bite of garlic without spitting it out.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Do 20 burpees or heavy jumping jacks as fast as humanly possible.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let another player look through your backpack, school bag, or room closet for 1 minute.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Pretend you are a monkey who has escaped from the zoo and run around the room making loud noises.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone put a funny sticker or piece of tape right on the tip of your nose.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Sing your least favorite song out loud with massive enthusiasm.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let another player completely redo your hairstyle into a giant mohawk or spikes.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Go outside and wave excitedly at a passing car or person like they are a celebrity.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Try to drink a glass of water while hanging your head upside down over a couch or chair.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group decide on an embarrassing story that you have to go tell an adult right now.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Act like a spoiled toddler throwing a massive temper tantrum over a broken crayon for 45 seconds.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone paint a silly design on your forehead using safe face paint or washable markers.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Eat a slice of bread with a weird topping combination chosen by the group (like mayo and sprinkles).',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Pretend to be a frog and hop down the hallway and back while making loud croaking sounds.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let another player use your arm as a canvas to draw a map to a hidden treasure.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Speak only in an electronic robot voice without moving your face muscles for the next 3 rounds.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Go to an adult and ask them very seriously for permission to adopt a pet alligator.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone put a big blob of whipped cream on your nose and leave it there for 2 rounds.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Do your best impression of a pop star performing a stadium concert with a broom as a microphone.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group choose a funny outfit out of your closet (or a pile of clothes) for you to wear for the rest of the game.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Try to spin around 10 times quickly and then immediately balance a book on your head.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone draw giant, funny anime eyes on your closed eyelids with a washable marker.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Eat a small piece of food directly off the floor (make sure it's a clean surface first!).",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Pretend you are a sub-zero ice cream cone that is melting radically fast in the hot sun.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let another player send a funny emoji-only text to a friend or sibling.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Go to the front yard or balcony and yell 'I am the king/queen of the world!' three times.",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Act like a scary zombie chasing the other players around the room for 1 minute.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone tickle your sides or feet for 20 seconds straight while you try not to laugh.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Do your best impression of a cat coughing up a hairball in front of everyone.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group give you a funny new name that you must respond to, or else you lose a point.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Try to balance a tennis ball or small toy on your forehead while walking backward.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone put a clean sock on your nose like an elephant trunk for the next 2 rounds.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Eat a small bite of a sandwich made out of crackers, peanut butter, and pickles.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Pretend you are a sumo wrestler preparing for a huge match in the center of the room.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let another player paint your big toe with a bright, vibrant color.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Go up to an adult and give them a massive hug for absolutely no reason at all.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Act like a chimpanzee trying to steal someone’s shoes.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone put a funny washable marker tattoo on the back of your neck.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Try to say the alphabet backward starting from Z as fast as you can.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Pretend you are a mad scientist who just created a monster out of peanut butter.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group choose a random object that you must carry everywhere with you for the rest of the game.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Go to a mirror, look at yourself, and give yourself an intense, funny pep talk for 1 minute.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone gently pour a tiny drop of cold water down your arm sleeve.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Act out a highly dramatic soap opera scene about a lost homework assignment.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Try to keep a totally straight face while someone tells you the funniest joke they know.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let another player draw a giant clock on your stomach with a washable marker.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Eat a spoonful of a mixture of cereal and a tiny splash of orange juice.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Pretend you are an old car that won't start, making sputtering and coughing noises.",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone put a funny hair clip right in the front of your hair.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Go to a window, open it, and whisper 'The birds are watching us' to the outside world.",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Act like an incredibly angry crab defending its favorite shell.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group choose a funny song that you have to dance to with zero music playing.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Try to balance a small pillow on your chin while walking in a circle.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone write a funny word on the bottom of your bare foot with a washable marker.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Eat a piece of cheese with a little bit of jam or jelly spread on top.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Pretend you are a superhero whose only superpower is making loud, funny noises.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let another player blindfold you and guess three different objects just by smelling them.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Go tell an adult a completely made-up, wild story about finding a alien spaceship in the backyard.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Act like a pig rolling around happily in a giant puddle of mud.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone put a piece of tape on your hand and pull it off quickly.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Try to sing a song with your mouth completely closed (humming aggressively).',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Pretend you are a T-Rex with tiny arms trying to eat a snack from a high table.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group create a silly obstacle course that you must complete blindfolded while they guide you.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Go to an adult and ask them for a glass of water, but call them 'Your Majesty' the entire time.",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Act like a sleepy sloth trying to cross a very busy highway.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone draw a tiny smiley face on the tip of your chin.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Try to hop on one foot while keeping your other hand touching your nose.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Pretend you are a professional auctioneer trying to sell a plain piece of paper as fast as you can.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let another player choose a crazy hat or accessory for you to wear for the next 5 rounds.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Eat a small piece of dark chocolate with a tiny pinch of salt or pepper on it.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Act like a giant gorilla beating its chest and roaring around the room.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let someone put a funny sticker on your cheek and leave it there until the end of the day.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Try to say a long sentence while holding your tongue with your fingers.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Pretend you are a ghost trying to scare everyone but you keep sneezing instead.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Let the group arrange your arms and legs into an awkward pretzel shape and hold it for 30 seconds.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Go outside and do 5 massive star jumps while shouting 'I love fresh air!'",
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: 'Act like a hyperactive squirrel searching for a hidden acorn under the couch cushions.',
    type: 1,
    category: 1,
    level: 3,
  },
  {
    name: "Do a giant, over-the-top bow and say 'Thank you, thank you, you've been a wonderful audience!'",
    type: 1,
    category: 1,
    level: 3,
  },
]

// ==================== FAMILY ====================
const truthFamilySweet = [
  {
    name: 'What is your absolute favorite family tradition?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If you could relive one family vacation, which one would it be?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the nicest thing a family member has done for you recently?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who in this room makes you laugh the hardest?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite home-cooked meal that someone here makes?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a happy memory you have with the person to your left?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If our family had a theme song, what do you think it should be?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite thing about our house/home?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the best listener in the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a nickname you have (or used to have) that you actually like?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the best piece of advice a family member has ever given you?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If you could buy any gift in the world for the person to your right, what would it be?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite holiday to spend with the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a talent or skill someone in this family has that you really admire?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the funniest thing that has ever happened at a family dinner?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What makes you feel most loved by this family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If you could describe our family in just three words, what would they be?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a movie or TV show that always reminds you of family time?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who was your favorite relative growing up?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the best compliment you have ever received from a family member?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a small, everyday habit of our family that you love?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If you could go on a dream vacation with everyone here, where would we go?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you are incredibly proud of achieving recently?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Which family member do you think you are most similar to?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite childhood memory involving someone in this room?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a food that always reminds you of home?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If you could swap lives with any family member for one day, who would it be?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you feel deeply grateful for today?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who in the family is most likely to cheer you up when you are sad?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite photo of our family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a hobby or activity you wish our family did more often together?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the most thoughtful card or letter you’ve received from someone here?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the most organized person in the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a funny phrase or inside joke that only our family understands?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you love about the way our family celebrates birthdays?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the most creative person in this room?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a lesson you learned from a parent or grandparent that stuck with you?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If you could give a trophy to any family member, what category would they win?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite game to play with the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you always look forward to doing with everyone here?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who in the family has the best style or fashion sense?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a story about our family history that you love to hear?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the best surprise you have ever received from a family member?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the most patient person in the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a book or story you love sharing with family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If you could magically learn any language for our next trip, what would it be?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: "What is your favorite comforting thing to do when you're at home?",
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the biggest animal lover in the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you appreciate about how you were raised?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a small gesture from a family member that always brightens your day?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If you could build a secret room in our house, what would you put in it?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who in the family gives the absolute best hugs?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite memory of a family pet (past or present)?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something new you want to learn or try with a family member?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the best cook or baker in the room?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a tradition from your childhood you want to pass down to future generations?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the most beautiful place you have ever visited with family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the most adventurous person in the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a song that instantly makes you happy when it plays in the car?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you really admire about the person sitting across from you?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite time of day to spend at home?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who in the family is the best at keeping secrets?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: "What is a quirky habit of our family that you wouldn't change for anything?",
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the best dessert anyone in the family makes?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If our family were characters in a movie, who would play who?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a project or chore you actually enjoy doing with someone else here?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the most tech-savvy person in the house?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a dream or goal you have that the family can help you achieve?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite lazy Sunday activity with the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the most energetic person in the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you feel safe talking to this family about?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the funniest face a family member makes?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a memory that always makes you smile no matter what?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the most generous person in our family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a cool skill you learned directly from a family member?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'If you could add one rule to the house that everyone had to follow, what would it be?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite memory of a family road trip?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who in the family has the most infectious laugh?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you look forward to every single week?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the best movie night snack our family makes?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the most encouraging person in your life right now?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a family heirloom or object in the house that you treasure most?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you love about our family dinners?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the best storyteller in the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a fun park or outdoor spot you love visiting with family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you are proud of our family for overcoming together?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who in the family is most likely to notice if you’re having a bad day?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite time of year to be at home?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a word or phrase that reminds you instantly of your parents?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the most reliable person when you need a favor?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a tradition you want to start with the family this year?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite corner or spot in the house to relax?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who in the family shares the most similar taste in music or movies with you?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the best piece of wisdom a relative passed down to you?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is something you love doing for other family members?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who is the biggest night owl in the family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is a gentle reminder from a family member that helped you grow?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is your favorite memory of a rainy day spent inside with family?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'Who in this room is the most optimistic?',
    type: 0,
    category: 2,
    level: 1,
  },
  {
    name: 'What is the number one reason you feel lucky to be a part of this family?',
    type: 0,
    category: 2,
    level: 1,
  },
]
const truthFamilyMild = [
  {
    name: 'What is a rule in this house that you secretly think is completely useless?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever accidentally broken something in the house and blamed it on someone else?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the messiest person in the family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a chore that you absolutely hate doing and always try to avoid?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "Have you ever eaten the last piece of a snack or dessert and pretended you didn't?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who takes the absolute longest to get ready in the morning?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the most embarrassing phase or trend you went through that the family remembers?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever faked being sick to get out of a family event or chore?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the loudest sleeper or snorer in the house?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a meal that someone makes here that you secretly really dislike?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever hidden remote controls or items just to annoy a family member?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the biggest backseat driver in the family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the silliest argument you have ever gotten into with a family member?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever re-gifted a present that a family member gave you?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most dramatic person in the family when they get sick?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a habit a family member has that drives you absolutely crazy?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever stayed up way past your bedtime and almost got caught?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most stubborn person in this room?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the worst haircut or outfit you have ever been forced to wear for a family photo?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever lied about finishing your homework or a chore?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the biggest hoarder or has the most clutter in their room?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the longest you’ve gone without showering, and did anyone notice?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever eavesdropped on a conversation between other family members?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the worst at texting back or answering phone calls in the family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "What is a secret purchase you made that you didn't want the family to know about?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever blamed a bad smell on a family pet or another person?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who gets the most competitive during family board games?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the most childish thing you still do or own?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "Have you ever snooped through a sibling's or parent's room without permission?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most forgetful person in the house?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a lie you told a family member that you feel slightly guilty about?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever accidentally ruined a piece of clothing belonging to someone else here?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the biggest screen-time addict in the family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing you’ve done in front of extended family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever pretended to love a gift just to make a family member happy?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to lose their keys or phone in the house?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a song or artist you secretly love but would be teased for listening to?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "Have you ever sneaked out of the house or into a room you weren't supposed to be in?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "Who gets the most 'hangry' (angry when hungry) in the family?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the biggest mess you have ever made in the kitchen?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "Have you ever used someone else's toothbrush or personal item by accident (or on purpose)?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to overpack for a weekend trip?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is an inside joke in the family that you think is actually pretty dumb?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever let a pet do something forbidden when no one else was looking?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the biggest gossip in our extended family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the worst cooking disaster you have ever personally caused?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever hidden wrappers or trash to hide the fact that you ate a snack?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most impatient when waiting in lines or traffic?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a pet peeve you have about the way our household chores are split up?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "Have you ever forgotten a family member's birthday or important date?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to overreact to a small problem?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the most ridiculous thing you believed as a child because a family member told you?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever borrowed money from a family member and hoped they would forget about it?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the pickiest eater in the family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a habit of yours that you know annoys everyone else in the room?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "Have you ever pretended to be asleep so you wouldn't have to help carry groceries?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the worst at singing but does it anyway?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the strangest food combination you eat when you are home alone?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever accidentally sent a text about a family member *to* that family member?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to wake up in a grumpy mood?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a fashion choice a family member is making right now that you secretly hate?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever watched a show or movie ahead of a family member when you promised to wait?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the biggest procrastinator in the house?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the silliest thing you have ever cried about as an adult or teenager?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever blamed a broken rule on a sibling or pet when it was 100% you?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to accidentally break a piece of technology?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is something you borrowed from a family member months ago and never returned?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever lied to get out of eating a specific family meal?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who makes the most corny or terrible jokes in the family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the most embarrassing nickname you have ever been called in public?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever pretended not to hear someone call your name to avoid doing a favor?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to get lost using GPS?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a house decoration we have that you think is completely hideous?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "Have you ever used a family member's streaming account without them knowing?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who has the messiest car or workspace in the family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the most useless piece of junk you refuse to throw away?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever hid in a room or bathroom just to get some peace away from the family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to burn the toast or pop-corn?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "What is a habit from childhood that you only recently found out wasn't normal?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever shrunk or ruined laundry and quietly put it back in the closet?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most easily scared or startled in the house?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the worst movie you have ever forced the family to watch together?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever eaten something that dropped on the kitchen floor and put it back?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the biggest softie or easiest to convince in the family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a story our parents always tell about you that you wish they would stop?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever accidentally left a door or window unlocked overnight?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to spill a drink at the dinner table?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "What is the funniest thing you've done while half-asleep in this house?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever snoozed an alarm so many times it made everyone else late?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to buy something online and immediately regret it?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a chore you always do poorly on purpose so someone else will take over?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever pretended to clean your room by just throwing everything in the closet?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the biggest cheapskate or saver in the family?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is a phrase a family member uses that makes you secretly roll your eyes?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever used the last of the toilet paper and left the empty roll?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to get overly competitive during a casual yard game?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: "What is the most embarrassing thing you've worn while just lounging around the house?",
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Have you ever lied about where you were going to escape a family gathering?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'Who is the most likely to forget where they parked the car?',
    type: 0,
    category: 2,
    level: 2,
  },
  {
    name: 'What is the one thing about living with this family that tests your patience the most?',
    type: 0,
    category: 2,
    level: 2,
  },
]
const truthFamilySpicy = [
  {
    name: 'If you had to choose only one family member to look after you if you were sick, who would it be?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a major life choice you made that you know the family secretly disapproved of?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "Have you ever felt genuinely jealous of a sibling's or family member's success?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a deep secret you have kept from the family for over a year?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'If you could legally change one thing about our family dynamic, what would it be?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most misunderstood person in this family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is your biggest regret regarding how you treated a family member in the past?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever seriously considered moving far away just to have space from the family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you find it hardest to communicate with in this room?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is something the family complains about that you secretly think is entirely their own fault?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever hidden a relationship or a major friendship from this family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a harsh truth about our family that we all choose to ignore?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who in the family do you think has changed the most over the last few years?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "Have you ever felt like an outsider or the 'black sheep' in this family?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is the biggest argument you’ve had with a family member that never truly got resolved?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'If you had to pick one family member whose lifestyle you absolutely do not want to emulate, who is it?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is something you lied about on your resume, at school, or at work that the family thinks is real?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most spoiled or privileged person in the family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a family tradition or habit that you secretly hope dies out?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever kept a financial secret or struggle completely hidden from everyone here?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is an assumption this family makes about you that is completely wrong?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who in the family do you think judge others the most harshly?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "What is something a family member did that broke your trust, even if they don't know it?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever felt unappreciated for the things you do for this household?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a political or social opinion you hold that you keep quiet about to avoid family fights?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the worst at handling crisis situations in the family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever resented a family member for a decision they made for the collective group?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is the closest you’ve ever come to getting into legal trouble without the family knowing?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who in the family do you wish would apologize to you for something past?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a insecurity you have that you are terrified the family will judge you for?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever lied to a family member to protect their feelings because the truth was too harsh?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think holds the most unhelpful grudges in this house?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is something you’ve done that would completely shock our parents or extended family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever felt like a family member favored someone else over you?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is the biggest lie you have ever told to get out of trouble with a parent or partner?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most emotionally distant person in the family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a personal failure you experienced that you hid from the family out of shame?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever felt trapped by family obligations or expectations?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who in the family do you think has the most unrealistic view of the real world?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is something a family member said to you years ago that still hurts your feelings today?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever hidden a bad habit or addiction from the people in this room?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most passive-aggressive person in the family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a piece of advice from a family member that you think was completely toxic or wrong?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever stayed in a situation or relationship longer than you should have because of family pressure?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you feel you have to walk on eggshells around the most?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is something you wish this family talked about openly instead of sweeping under the rug?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever blamed a massive mistake you made on bad luck rather than admitting the truth to the family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most underappreciated person in our family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a part of your daily life or identity that you completely filter when you are around family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "Have you ever felt like your boundaries weren't respected by someone in this room?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think causes the most unnecessary drama during family gatherings?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a truth about yourself that you are still trying to accept, let alone tell the family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever kept a medical or mental health struggle a secret from everyone here?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most stubborn person when it comes to admitting they are wrong?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a decision our family made together in the past that you still think was a mistake?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "Have you ever felt pressure to compete with another family member's achievements?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think has the hardest time letting go of the past in this family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a secret someone in the family trusted you with that you have never repeated until now?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever modified your personality or beliefs just to fit in better at family events?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the worst listener when important topics are brought up?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is something you wish you could change about the way you were disciplined or raised?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever felt genuinely let down by a family member when you needed them most?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most enabling person in our family dynamic?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a truth you want to tell someone in this room right now but are too afraid of the reaction?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever felt like your career or life choices were mocked or minimized by family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who in the family do you feel understands you the least?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "What is a boundary you desperately need to set with a family member but haven't yet?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "Have you ever pretended to agree with a family member's rant just to make them stop talking?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think carries the heaviest emotional burden in this family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a mistake you saw a family member make that taught you exactly what *not* to do?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever felt like you had to choose between a friend/partner and your family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most overly critical person in this room?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "What is a question you've always wanted to ask a parent or relative but never had the courage to?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "Have you ever felt like your accomplishments were overshadowed by someone else's in the family?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most financially irresponsible person in the family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a family rule or expectation that you completely intend to break in the future?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "Have you ever felt like you had to carry a secret to protect the family's reputation?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who in the family do you think is the best at manipulation?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a habit of a family member that you are genuinely worried will cause them harm?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever felt like you were living in a sibling’s or parent’s shadow?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most close-minded person in our extended family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "What is something you've done out of spite against a family member that they never found out about?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "Have you ever felt like you couldn't be your true self around this family?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the quickest to lose their temper in this house?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "What is a childhood promise you made to a family member that you know you won't keep?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever hidden a major life milestone (good or bad) from the family for a long time?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think has the most toxic relationship with social media in the family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a harsh reality check you think a family member desperately needs to hear?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever felt like your personal space or privacy was completely violated by family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the worst at accepting constructive criticism in this room?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "What is something you've sacrificed for this family that no one else realizes?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: "Have you ever felt like a family member's love for you was conditional on your performance?",
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most emotionally exhausting person to spend a full day with?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a grievance or hurt from the past that you are honestly struggling to forgive?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever felt like the expectations placed on you by this family are completely unfair?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most prone to making excuses for their bad behavior?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is a truth about your childhood that you remember differently than your parents do?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Have you ever stayed silent during a family fight when you knew exactly who was right?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'Who do you think is the most genuinely happy person in our family?',
    type: 0,
    category: 2,
    level: 3,
  },
  {
    name: 'What is the single most important thing this family could do to become closer or healthier?',
    type: 0,
    category: 2,
    level: 3,
  },
]
const dareFamilySweet = [
  {
    name: 'Give the person to your left a high-five and a compliment.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do your best impression of a family pet for 30 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Balance a spoon on your nose for 10 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Speak in a British accent until your next turn.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give someone in the room a gentle, 10-second back massage.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: "Do 10 jumping jacks while saying 'I love my family!' after each one.",
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: "Sing the chorus of your favorite song using only the word 'meow'.",
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to touch your tongue to your nose.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Act like a chicken laying an egg for 20 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Let the youngest person in the room style your hair anyway they want.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Spin around in a circle 5 times and then try to walk a straight line.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Tell a funny joke and try not to laugh while telling it.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Hold a funny face for 30 seconds while everyone tries to make you laugh.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do your best runway model walk across the room.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Make up a 15-second handshake with the person opposite you.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend you are an opera singer and sing what you did today.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give a 30-second speech about why your family is awesome.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do your best robot dance for 30 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Let someone trace a word on your back and try to guess what it is.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Wiggle your ears or eyebrows without using your hands.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Hop on one foot across the room and back.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Speak in slow motion for the next two rounds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend you are an airplane and fly around the room once.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give the oldest person in the room a big, warm bear hug.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do your best impression of a crying baby.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to balance a pillow on your head while walking in a circle.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Make a funny face and take a group selfie with whoever is next to you.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: "Sing 'Happy Birthday' to the person on your right as if you are crying.",
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend to be a statue for 1 full minute without blinking or moving.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: "Do your best monkey impression while looking for bugs on someone's head.",
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Whisper everything you say for the next round.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to juggle three crumpled pieces of paper for 15 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Act like a penguin walking on ice for 30 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give a shout-out to someone in the family who cooked or helped out today.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: "Pretend you are an announcer introducing the next person's turn.",
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do a dramatic death scene from a movie.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to repeat three difficult tongue twisters fast without failing.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Act like a frog hopping around the living room.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give a warm hug to the two people closest to you.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend you are a mime stuck in a glass box for 30 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do your best impression of a T-Rex with short arms.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Talk without moving your lips for the next round.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Walk backwards everywhere you need to go for the next 5 minutes.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Strike 3 different superhero poses in a row.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend to play an intense guitar solo using an invisible guitar.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do your best evil laugh for 10 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Draw a quick portrait of the person sitting opposite you in 1 minute.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend you are a cat trying to catch a laser pointer.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to snap your fingers using your non-dominant hand 5 times.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Name 5 things you love about the room you are currently sitting in.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend to be a crab and walk sideways across the room.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Sing your next sentence instead of speaking it.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give a standing ovation to the person who did the last dare/truth.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to balance a coin on the tip of your finger for 10 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Act like you just won an Oscar and give a tearful acceptance speech.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do your best impression of an elephant using your arm as a trunk.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Crawl like a baby for 30 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend to open a super sticky jar of peanut butter dramatically.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: "Bow deeply to everyone in the room and say 'Your Majesty'.",
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to make yourself look as tall as possible for 1 minute.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do a silly dance with no music for 30 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend you are walking through deep, thick mud.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: "Act like a dog that just heard the word 'Walk!'.",
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Say the alphabet backwards as fast as you can.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give a high-five to every single person in the room.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend to be a sleepy sloth trying to wake up.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to keep a piece of paper in the air by blowing on it.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Act like a chef describing a gourmet meal made of mud and bugs.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do 5 pushups while smiling at the person in front of you.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend you are a secret agent looking for hidden cameras.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: "Say 'Bingo!' every time anyone laughs for the next two rounds.",
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Put a piece of clothing on backwards for the rest of the game.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend you are a fish blowing bubbles out of water.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Act like a salesperson trying to sell a plain pen to the group.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give the person on your left a gentle knuckle bump.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do your best impression of a ninja sneaking through the kitchen.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Stand on one foot with your eyes closed for 15 seconds.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend to be a dynamic fitness instructor giving a quick 20-second workout.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to tickle yourself without laughing.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Say five nice things about yourself out loud.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend you are a kangaroo hopping to the bathroom and back.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Yawn dramatically and see how many people you can get to yawn too.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend to be an alien experiencing gravity for the first time.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do your best impression of a sports commentator calling this game.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Hug a pillow tightly and tell it your deepest affection.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Act like a zombie waking up and looking for brains.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to pat your head and rub your stomach at the same time.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend you are a cowboy riding a wild horse.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Make up a silly 4-line poem about the family right now.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Act like a snake slithering across a small part of the floor.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give a 10-second cheer for the family like a cheerleader.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend to be a statue that secretly changes poses when people look away.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Try to whistle a famous song until someone guesses what it is.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Act like an old man or woman complaining about modern technology.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give a thumbs up and hold a giant grin for the next full minute.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend to eat a giant lemon and show your most sour face.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Do a slow-motion run towards someone and give them a high-five.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Act like a baby bird waiting to be fed by its parents.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Pretend you are a racecar revving its engine and taking a sharp turn.',
    type: 1,
    category: 2,
    level: 1,
  },
  {
    name: 'Give everyone in the room a creative nickname for the rest of the game.',
    type: 1,
    category: 2,
    level: 1,
  },
]
const dareFamilyMild = [
  {
    name: 'Let the group text something funny to one of your friends from your phone.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Mix two random liquids from the fridge (like milk and juice) and drink a sip.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Wear your socks on your hands for the next three rounds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone write a silly word on your forehead with a washable marker.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Do your best impression of [insert family member's name here] right now.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the person to your right restyle your eyebrows using a little water or gel.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Call a relative who isn't here and sing them 'Happy Birthday' out of nowhere.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Eat a slice of bread with a weird topping chosen by the group (e.g., ketchup).',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Wear a funny hat or an item of clothing belonging to someone else until the game ends.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Let the group look through your phone's camera roll for 30 seconds.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Do 15 squats while loudly counting backwards from 50.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Speak only in rhymes for the next two rounds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone in the family give you a dramatic makeover using whatever is nearby.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Blindfold yourself and try to guess 3 family members just by touching their hands.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Talk to a household object (like a lamp or chair) as if it's your best friend for 1 minute.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone brush your teeth for 20 seconds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Eat a spoonful of hot sauce or mustard without drinking water for 1 minute.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Put ice cubes in your hands and hold them until they melt completely.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Do your best impression of your parents arguing about directions or chores.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the group post a silly comment on your most recent social media post.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Dance like a maniac with no music until you are completely out of breath.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Serenade the family pet or a houseplant with a dramatic love song.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Allow someone to tickle you for 15 seconds without you flinching.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Wear your pants inside out for the remainder of the game.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the person on your left draw a funny mustache on your face.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Keep an ice cube down your shirt until it melts.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Eat a slice of lemon without pulling any face or squinting.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Do your best impression of the most dramatic family dinner ever.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the person youngest in the room dictate what you wear for the next hour.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Read the last 3 text messages you received out loud to the room.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Pretend to be a waiter and serve everyone drinks with an exaggerated accent.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone style your hair into a crazy mohawk or pigtails.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Keep your eyes wide open and don't blink for 45 seconds.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Drink a glass of water without using your hands at all.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Do a dramatic reading of a random recipe from the kitchen.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone in the room look through your search history for 30 seconds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Try to stuff 3 large marshmallows (or equivalent food) in your mouth and sing a song.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Walk around the outside of the house or down the hallway singing loudly.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the group pick a funny YouTube video that you have to mimic perfectly.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Stand in the corner of the room facing the wall for the next two rounds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Smell everyone's feet in the room and rank them from best to worst.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone dump a small cup of cold water over your head.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Speak like a pirate until it is your turn again.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Allow the person to your right to pinch your cheeks tightly for 10 seconds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Eat a raw piece of onion or garlic without gagging.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Do your best impression of a baby learning how to walk for 1 minute.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the group choose a weird outfit for you to wear for the rest of the night.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Lie on the floor and pretend to be a piece of sizzling bacon.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Try to wrap yourself up completely like a mummy using toilet paper.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone use your phone to send a completely random emoji to your crush or boss.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Bark like a dog every time someone says the word 'the' for the next 5 minutes.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the person on your left paint one of your fingernails with permanent marker or polish.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Crack an egg over your head (do this over a towel or outside!).',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Do 20 lunges while repeating 'I am the master of fitness'.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone put a piece of tape on your arm and rip it off quickly.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Eat a spoonful of mayonnaise mixed with sprinkles or relish.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Talk in a high-pitched chipmunk voice for the next three rounds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone rewrite your social media bio for the next 24 hours.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Snort like a pig every time you laugh for the rest of the game.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the group give you a funny new nickname that you must answer to all night.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Do your best impression of a crying toddler in a grocery store.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone feed you a mysterious snack while your eyes are closed.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Try to balance an apple or orange on your head while doing 3 squats.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Stand on your chair and shout 'I have a confession to make!' then sit back down.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Wear a trash bag as a shirt for the rest of the game.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone write a funny note on a piece of paper and tape it to your back.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Act like a monkey trying to escape from a zoo for 1 minute.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Dip your finger into hot sauce and wipe a tiny bit on your tongue.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone brush your hair aggressively for 1 minute.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Talk to your own shadow as if it is a long-lost friend.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Eat a small piece of paper with your name written on it.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the person next to you check your screen time on your phone.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Try to say the alphabet completely backwards while jumping on one foot.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Sit on the floor like a dog and beg someone for a treat.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone put a blindfold on you and guess 3 random objects from the kitchen.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Do your best impression of a fashion designer reviewing everyone's current outfits.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Imitate a crying ghost haunted by bad family dinners.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone tickle the bottoms of your feet for 10 seconds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Wear your shoes on the wrong feet for the next three rounds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Act like a wild wolf howling at the moon outside your window.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the group scroll through your Spotify/Apple Music heavy rotation playlist.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Try to drink a cup of water while hanging upside down slightly off the couch.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Do your best impression of a news anchor reporting on this family game.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone draw a tiny heart on your cheek with lipstick or liner.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Eat a small pinch of salt or pepper directly off your hand.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Pretend you are a cat licking your paws and wiping your face for 30 seconds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone put a wet paper towel down your back.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Try to pick up a pencil from the floor using only your toes.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Speak using only 3-word sentences for the next two rounds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the group look at your most embarrassing old photo on your phone.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: "Act like a security guard inspecting everyone's hands before they can play.",
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone give you a wet Willie (wet finger in the ear—keep it safe!).',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Do a funny belly dance in front of everyone for 20 seconds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Try to eat a dangling piece of food off a string without using your hands.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Pretend you are a caveman trying to explain how a smartphone works.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let the group choose a funny song that you have to lip-sync perfectly.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Wear a blanket like a cape and pretend to be a terrible superhero.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Try to spin a pillow on your finger like a basketball for 10 seconds.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Let someone blow air directly into your face while you try not to blink.',
    type: 1,
    category: 2,
    level: 2,
  },
  {
    name: 'Do your best impression of a malfunctioning robot trying to sit down.',
    type: 1,
    category: 2,
    level: 2,
  },
]
const dareFamilySpicy = [
  {
    name: 'Let the family choose an embarrassing text message and send it to your ex or crush.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a random number and try to stay on the line for 1 minute without hanging up.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone in the room shave a tiny section of your leg, arm, or eyebrow (if brave!).',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a sandwich containing 5 ingredients chosen entirely by the group.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group scroll through your deleted photos folder on your phone.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Go outside and yell 'I wet my bed until I was 15!' as loud as you can.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the person you clash with most in the family style your clothes for tomorrow.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Show the group the most embarrassing video or photo stored on your device.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Let someone send an email to your teacher or boss saying 'I love you' (must clarify after!).",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Do a funny dance outside on the front porch or sidewalk for 1 full minute.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the person to your left scroll through your direct messages on Instagram/TikTok.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a small spoonful of butter mixed with hot sauce and vinegar.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone cut a tiny piece of your hair off.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Call a local restaurant and try to order something that isn't on their menu.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group look through your notes app on your phone.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone write a highly embarrassing word on your forehead in permanent marker.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Call your parents (or another relative) and tell them you got arrested, then reveal it's a dare.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group choose a TikTok dance that you must perform completely and post it.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a piece of dog or cat food (substitute with something gross if unsafe).',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the youngest person in the house give you a complete facial using kitchen ingredients.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Post an incredibly cringey selfie on your main social media story for 2 hours.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone search through your bedroom or bags for 2 minutes without you interfering.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a friend and break up with them (as a friend), then call them back to explain.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the person on your right look through your Amazon or online shopping history.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Do 50 pushups, and if you can't finish, let the group paint your face like a clown.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone use your phone to call a random contact and speak to them as an alien.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group choose a secret about you that you have to confess to a relative right now.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Go to a neighbor's house and ask to borrow one single piece of toilet paper.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone wax a small patch of hair off your arm or leg using tape or wax.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a spoonful of plain flour without choking or drinking water.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group dictate a highly awkward text message to send to your group chat.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Call your best friend's parents and tell them they are your true inspiration.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone draw a giant, funny tattoo on your back or arm with ink.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Wear a sign that says 'Honk if I'm silly' and stand outside for 3 minutes.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group check your bank account balance out loud.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Drink a mystery smoothie made of things found in the fridge door.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone scroll through your blocked list and explain why you blocked each person.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a pizza place and try to break up with the person answering the phone.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group choose an embarrassing childhood story that you must text to a relative.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Put your face in a bowl of ice water for 20 seconds straight.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone put makeup on your face while they are completely blindfolded.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Call a relative and whisper 'I know what you did' then hang up immediately.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Let the person on your left send a text message to anyone in your phone saying 'I'm engaged'.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a cold, raw hot dog or a slice of raw potato dipped in maple syrup.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group see the last 10 things you searched for on your browser.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Go outside and do your best wolf howl at the top of your lungs 3 times.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone check your screen time and violently roast your habits.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a fast-food place and ask if they can hold a wedding reception there.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group choose an old Facebook or Instagram post of yours to delete permanently.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a spoonful of sour cream mixed with soy sauce.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone paint your toes using a color they pick and keep it on for a week.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Call a random contact and sing the entire chorus of 'Let It Go' out loud.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group look through your saved or bookmarked posts on social media.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Go outside and pretend to mow the lawn with an invisible lawnmower for 2 minutes.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone write an embarrassing review of a local business using your profile.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a bite of a lemon with salt, pepper, and hot sauce on it.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group choose who gets to give you a light spanking or flick on the arm.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a friend and pretend you completely forgot who they are.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone rearrange the apps on your phone home screen completely.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Go outside and ask a stranger (or neighbor) if they believe in aliens dramatically.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group scroll through your archived or hidden chats on messaging apps.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a spoonful of mustard mixed with sugar.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone draw a funny unibrow on your face that you must keep all evening.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a customer service line and try to complain about something completely made up.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Let the group choose a contact for you to send a voice note saying 'I miss your smell'.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Pour a cup of cold water directly down your pants.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone give you a major wedgie (keep it safe and funny!).',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a relative and ask them for money for a completely ridiculous fake business.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group see your Tinder/dating app profile or your old high school yearbook.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a raw egg yolk in one single gulp.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone put a blindfold on you and feed you 3 separate mystery foods.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Go outside and run around your house or yard 3 times in your pajamas.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group write an awkward status update and post it on your Facebook/Twitter.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a local hotel and ask if they have a room available for a pet alligator.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone inspect your closet and pick out your absolute ugliest piece of clothing.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a slice of cheese topped with peanut butter and hot sauce.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group send a text to your boss or teacher asking for a hug.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Go out to the mailbox or front gate acting like a ninja avoiding laser beams.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone dump a cup of ice cubes down your shirt while you stand completely still.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a friend and tell them you are secretly moving to Mars tomorrow.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group go through your purse, wallet, or backpack completely out loud.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a spoonful of chili powder or cayenne pepper (have water ready!).',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone use your phone to change your ringtone to something highly embarrassing.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Go outside and wave intensely at every car passing by for 2 minutes.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group pick a song that you have to sing dramatically from the front porch.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a random number and ask if their refrigerator is running, then deliver the joke.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone give you a temporary tattoo on your neck with a regular pen.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a piece of toast with mayonnaise, pickles, and chocolate syrup.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group look at your most embarrassing old text messages with an ex.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Go outside and ask the grass for permission before you step on it.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone put a piece of ice down your pants until it completely melts.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Call a store and ask if they sell camouflage pants, then complain you can't find them.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group choose a crazy hairstyle for you to wear out in public tomorrow.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Eat a spoonful of relish mixed with hot chocolate mix.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: "Let someone scroll through your phone's call history for the past week.",
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Go outside and do a dramatic dramatic interpretation of a tree in a storm.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group choose a random photo from your camera roll to print or share.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Call a relative and try to speak to them entirely in a fake foreign accent.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let someone put a piece of tape over your lips for the next 15 minutes.',
    type: 1,
    category: 2,
    level: 3,
  },
  {
    name: 'Let the group decide your ultimate punishment if you refuse any future dare.',
    type: 1,
    category: 2,
    level: 3,
  },
]

// ==================== Boyfriend ====================
const truthBoyfriendSweet = [
  {
    name: 'What was your exact first impression of me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'When did you realize you actually had feelings for me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your absolute favorite memory of us together?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one little thing I do that always makes you smile?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If we could fly anywhere in the world right now for a date, where would we go?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What song always reminds you of me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite physical feature of mine?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is the nicest thing I have ever done for you?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What outfit of mine is your absolute favorite?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If you had to describe our relationship in three words, what would they be?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a habit of mine that you find surprisingly endearing?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite way to receive affection from me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What was going through your mind during our very first kiss?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a dream or goal you want us to achieve together?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What text from me made you smile the hardest?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If you could recreate any date we’ve ever had, which one would it be?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite nickname that I call you (or that you want me to call you)?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing about me that makes you feel safe?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'How did you tell your friends or family about me for the first time?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a hobby of yours that you secretly want to teach me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What movie or TV show character reminds you most of me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is the best piece of advice you’ve ever received about love?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing you’re proud of me for achieving recently?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If you could buy me any gift in the world regardless of price, what would it be?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite time of day to spend with me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is something new you've tried or learned because of me?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a silly tradition you want us to start?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite photo of us together?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one personality trait of mine that you wish you had more of?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If we were a team in a game show, what would our team name be?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is the most romantic thing you’ve ever planned or want to plan for me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "How do you feel when we haven't seen each other for a few days?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite memory of us from last winter?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is the most comforting thing I can say to you when you're stressed?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If you had to write a poem or song title about our love story, what would it be?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite meal that we’ve shared together?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is something you always look forward to doing with me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a hidden talent of mine that you love to brag about to others?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is the best compliment I have ever given you?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If our relationship was a movie genre, what would it be?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite way to cuddle with me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing you always notice about me the second I walk into the room?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a small gesture of love that means the world to you?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If you could freeze time during one moment we shared, which moment would it be?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite scent or perfume/cologne that I wear?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is something I did recently that made you feel deeply loved?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is a childhood memory you haven't told me yet but want to share?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite lazy Sunday activity for us to do?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What part of my personality makes you feel the most proud to be my boyfriend?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is the best thing about sharing a life/routine with me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If you could pick our next vacation spot completely on a whim, where are we going?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a silly habit of yours that you only feel comfortable doing around me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite inside joke that we have?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is something I do that makes you feel incredibly respected?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If you could describe my laugh in one sentence, what would you say?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite season to spend with me and why?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing you hope never changes about our relationship?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is the most thoughtful gift you've ever received from anyone, and why?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is a song that you secretly think is 'our song' even if we haven't agreed on it?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is something you love doing for me when I’m having a rough day?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite way for us to spend a rainy afternoon?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing you’ve learned about yourself since we started dating?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite memory of us with family or friends?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a character trait of mine that you think will make me an amazing partner long-term?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is the most creative date idea you've secretly thought about doing with me?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite sweet treat or comfort food to share with me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a book, movie, or game you think I would love if I gave it a chance?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one small thing I do that gives you butterflies?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is the most peaceful moment you've ever experienced with me?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If you could spend a whole day doing absolutely nothing with me, what would it look like?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is your favorite physical touch from me that isn't kissing?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is something about our future together that you think about the most?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is the best adventure or road trip we’ve taken together?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a fashion style or clothing item you think looks absolutely amazing on me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing you always tell your best friend about how great our relationship is?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite memory of us celebrating a holiday or achievement?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is something you never thought you'd enjoy until I introduced you to it?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a word or phrase I use frequently that you find adorable?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite way to wake up next to or get a morning text from me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a hidden passion or dream of yours that you feel safest sharing with me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is the most beautiful place you have ever seen me smile?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a small everyday chore that you actually enjoy doing with or for me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite memory of us cooking or eating together?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing you are completely certain of when it comes to us?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'If you could dedication a whole day to pampering me, what would you do first?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite memory of us from when we were first getting to know each other?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing you love about the way we handle disagreements?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a funny face or expression I make that you absolutely adore?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is something you're looking forward to doing with me next month?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: "What is your favorite memory of a time we couldn't stop laughing together?",
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing about my family or background that you find wonderful?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a quote, lyric, or saying that perfectly captures how you feel about me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite way to show me you care without using words?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is something you love about our texting dynamic?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is the most magical or dream-like date you could ever imagine us having?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing you do to make sure I know you appreciate me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is your favorite memory of us just talking late into the night?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is a skill or strength of mine that you constantly admire?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is one thing you always carry with you that reminds you of me?',
    type: 0,
    category: 4,
    level: 1,
  },
  {
    name: 'What is the single happiest second you have ever experienced by my side?',
    type: 0,
    category: 4,
    level: 1,
  },
]
const truthBoyfriendMild = [
  {
    name: 'Have you ever pretended to like a food I made just to be polite?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a habit of mine that secretly drives you a little bit crazy?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What was your worst fear about our relationship when we first started dating?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever snooped through my room or looked at my phone screen when it buzzed?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing that has happened to you while we were together?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever lied about being busy just to have some alone time/gamer time?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What did your friends genuinely think of me when they first met me?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a white lie you told me early on in the relationship to impress me?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever felt a tiny bit jealous of any of my friends or coworkers?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most useless thing you’ve ever bought because you thought it made you look cool?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is an opinion or perspective of mine that you completely disagree with but don't bring up?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever practicing a conversation or joke in the mirror before seeing me?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the longest you’ve gone without showering when we weren’t seeing each other?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a movie or song you secretly love but pretend to hate in front of others?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'If you could change one minor item in my wardrobe or closet, what would it be?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever re-gifted something I gave you, or thought about re-gifting it?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is your biggest pet peeve about how I text or use my phone?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the dumbest argument we’ve ever had, in your honest opinion?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever blamed a weird smell or a mess on something else when it was actually you?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a secret habit you have when you are completely alone in the house?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'If my friends were in trouble, which one would you be least excited to go help or bail out?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most childish thing you still do or own?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever pretended to know a lot about a topic I was talking about when you had no clue?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is your real opinion on my favorite television show or movie?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever looked at my ex’s social media profiles out of curiosity?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the closest you’ve ever come to getting caught doing something you shouldn’t have?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a fashion trend I follow that you secretly think looks ridiculous?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever deleted your browser history right before letting me borrow your phone or laptop?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most awkward encounter you’ve ever had with my parents or family?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'If you could mute one phrase or word that I say all the time, what would it be?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever forgotten an anniversary, birthday, or important date of ours and scrambled?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is your go-to lie when you want to get out of a social event with people you don't like?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever been genuinely annoyed by a gift I gave you, even if you smiled?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is something you do that you know annoys me, but you do it anyway because it’s fun?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most embarrassing text you’ve accidentally sent to the wrong person?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "Have you ever pretended to sleep just so you wouldn't have to get up or talk?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a physical feature of yours that you are secretly most insecure about?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the worst haircut or style choice you have ever made in your life?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever felt competitive with me over something completely silly?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a rule your parents had growing up that you broke constantly without them knowing?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'If you had to pick one of my friends to be stranded on a desert island with, who would it be?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever faked being sick or hurt to get sympathy or attention from me?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most money you’ve ever spent on something completely stupid and regretted?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is an item of clothing I own that you wish I would throw away or lose?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever accidentally broken something of mine and hidden it or replaced it secretly?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a nickname your family used to call you that you absolutely hate?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is your least favorite chore that you always try to get out of doing?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever stalked yourself or googled your own name to see what comes up?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the weirdest food combination that you secretly love to eat?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is something you are terrified of that most people find completely normal?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever pretended to be interested in a story I was telling when your mind was totally blank?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most embarrassing song on your current playlist?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever lied to your parents about where you were going when you were coming to see me?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a habit of mine in the kitchen or during meals that makes you cringe a little?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'If you could trade one of my personality traits for one of your best friend’s traits, would you?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever checked your hair or outfit in a store window reflection when you thought no one looked?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the worst date you have ever been on prior to our relationship?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever kept a secret from me because you knew it would result in a 2-hour discussion?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is something you always forget to do, no matter how many times you're reminded?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever been jealous of a celebrity or fictional character that I find attractive?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is the most ridiculous excuse you've ever used to get out of trouble at work or school?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a bad habit you have that you are trying really hard to hide from me?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "Have you ever laughed at a joke of mine that you didn't actually understand?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most awkward phase you went through in middle school or high school?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever exaggerated a story to make yourself look cooler in front of my friends?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is your honest opinion about my driving skills?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "Have you ever worn an item of clothing twice in a row hoping I wouldn't notice?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing your parents have ever revealed about you to me?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever looked through my music playlists and judged my taste in songs?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a bad habit of yours that your family always warns people about?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever stayed up way too late playing video games or scrolling and lied about it the next morning?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is the most petty reason you've ever gotten mad at someone?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever pretended to like a sport, team, or hobby just to fit in with a crowd?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is something I do when I'm angry that you find secretly funny instead of scary?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever been caught talking to yourself out loud?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most awkward compliment someone has ever given you?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "Have you ever hidden snacks or food so you wouldn't have to share them with me?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is a skill you tell people you have but you're actually terrible at?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever been genuinely afraid of a bug or spider and had to pretend to be brave for me?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is the most embarrassing thing you've done while intoxicated or sleep-deprived?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever disagreed with how I spent my money but kept your mouth shut?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is a guilty pleasure reality show or YouTube rabbit hole you watch when I'm not around?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever tried on my clothes or accessories just to see how they look on you?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is the worst lie you've ever told an authority figure or teacher?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever been caught looking at your phone during a romantic dinner or movie with me?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a physical quirk of mine that you noticed on day one but never brought up?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever lied about liking a movie we watched together just because I loved it?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is the most embarrassing username or email address you've ever created?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever accidentally ruined a surprise party or a gift before the reveal?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is something you bought for yourself that you lied about the price of to me?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "Have you ever practiced saying 'I love you' before you actually said it to me?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is a household rule of ours that you secretly think is totally unnecessary?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever yawned during a serious conversation because you were bored?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'What is the most basic or uncool thing about your daily routine?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever been jealous of the attention I give to a pet or a hobby?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is the worst piece of relationship advice you've ever ignored?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever pretended to understand a deep movie when you were completely confused?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is an internal nickname you have for me when I'm being stubborn?",
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: 'Have you ever looked at my old social media photos from years before we met?',
    type: 0,
    category: 4,
    level: 2,
  },
  {
    name: "What is the funniest thing you've ever done to save money that looked incredibly cheap?",
    type: 0,
    category: 4,
    level: 2,
  },
]
const truthBoyfriendSpicy = [
  {
    name: "What is your ultimate, wildest romantic fantasy that you haven't told me yet?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is a secret vulnerability or fear of yours that you haven't shared with anyone else?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is something you want to try in the bedroom but have been too nervous to ask for?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever had a dream about someone else since we started dating?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the biggest regret you have about your past romantic or dating life?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What part of my body or physical appearance drives you completely crazy with attraction?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever doubted whether we are truly compatible long-term?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a secret about your past that you are terrified I might find out?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'When was a time you felt incredibly insecure or threatened in our relationship?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most physically intense or memorable moment we have ever shared?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever compared our relationship or intimacy to your past relationships?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is something I do during intimacy that you secretly wish I did differently or more often?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the biggest lie you have ever told me without getting caught?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever developed a temporary crush on someone else while we’ve been together?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is your real, unfiltered opinion on my closest friends or family members?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is a boundary of yours that you feel I have crossed but you didn't address it?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'If you could erase one argument or event from our relationship history, what would it be?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most physically attractive thing I can wear to turn you on instantly?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like you were losing your independence or identity by being with me?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is a dark or weird thought you've had that you've never spoken aloud?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the closest you’ve ever come to breaking up with me or walking away?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt unappreciated or taken for granted by me for an extended period?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a bad habit or trait of mine that you worry might worsen as we get older?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is something you find incredibly attractive about me that isn't physical at all?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever hidden a significant financial decision, debt, or purchase from me?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a secret temptation you’ve faced since we’ve been exclusive?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most vulnerable you have ever felt while looking into my eyes?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like you have to change who you are to make me happy?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is your ultimate dealbreaker in a relationship that I might be close to touching?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is an insecurity you have about your performance or presence in our private life?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever kept a piece of memorabilia or an item from an ex-partner secretly?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a question you have always wanted to ask me but were too afraid of the answer?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the meanest thought you’ve ever had about me during an intense argument?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt overwhelmed by how much I love you or how fast things move?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a secret desire you have for our future living arrangements or lifestyle?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the biggest sacrifice you feel you’ve made for the sake of this relationship?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "Have you ever flirted with someone else online or in person just to see if you still 'had it'?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most unconventional thing you find sexually or physically appealing?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'When was the last time you cried when you were completely alone, and what caused it?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is something you think I am totally blind to when it comes to my own behavior?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like I was judging you or your choices unfairly?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a secret dream career or lifestyle you want, even if it meant moving away?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most intense emotion you have ever felt toward me (good or bad)?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever told a friend a deep secret about our relationship that you promised to keep?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is your honest assessment of how well we communicate when things get tough?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a physical touch or act you secretly dislike but tolerate because you know I love it?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like my past relationships or exes cast a shadow over us?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a mistake you made in a past relationship that you are actively trying not to repeat with me?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most raw, unfiltered confession you want to make to me right now?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like you are carrying more weight or effort in this relationship than me?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a taboo topic or fantasy you think about but think society would judge you for?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'When did you feel the absolute most connected to me on a spiritual or emotional level?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever wished I would take charge or be more dominant in a specific situation?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is a flaw of mine that you have learned to love, even though it's difficult?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever had a gut feeling or intuition about us that scared you?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is something you think I am hiding or holding back from you?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is your favorite part of my naked body, and why does it stand out to you?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt lonely even when we were sitting right next to each other?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most challenging thing about being in a relationship with me?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a secret source of anxiety or stress in your life that you keep completely to yourself?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like you were competing with someone else for my time or affection?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a fantasy or scenario you think about when we are apart to get you in the mood?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most painful truth you’ve ever had to accept about yourself?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "Have you ever felt like I don't fully understand or validate your emotions?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a hidden side of your personality that you keep hidden from the rest of the world?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever doubted your own readiness for a serious, committed relationship?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is the most adventurous place you've ever thought about hooking up with me?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is something you wish I would praise or compliment you on more often?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt judged by my friends, and did it change how you view them?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is a secret expectation you have of me that you haven't explicitly communicated?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'When was a time you felt genuinely disappointed in an action or decision I made?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most intense secret you’ve kept for a friend that you can never tell me?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt suffocated by our relationship routine or schedule?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a specific look or expression I give you that makes you want to drop everything and be alone with me?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is something about your family dynamic or childhood that deeply shapes how you treat me?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like you were putting on a mask or a brave face for me when you were breaking inside?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is a physical sensation or experience you've only ever felt with me?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "Have you ever looked at our relationship and wondered 'what if' about an alternative path in life?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is the most embarrassing thing you've ever done to get my attention or keep me interested?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a habit of mine that makes you worry about our future health or lifestyle together?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt a surge of intense jealousy over an interaction I thought was completely innocent?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is your true definition of intimacy, and do you feel we have achieved it yet?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a romantic risk you want us to take together that scares you a little bit?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like I prioritize other things (work, friends, hobbies) over your needs?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a secret memory of us that always gets you flustered or blushing when you think of it?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most difficult conversation you think we still need to have?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever worried that the spark or excitement between us is fading, even for a moment?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a personal goal you’ve abandoned because it didn’t align with our relationship?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most intense physical craving you have when you think about me?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like you had to hold back your true opinions because you feared my reaction?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is something you've done purely to make me happy, even though it made you deeply uncomfortable?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever had a secret dream or thought about marriage, kids, or moving in that you hid to avoid pressure?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: "What is the most profound lesson you've learned from a heartbreak before me?",
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like you were losing the power dynamic or control in our relationship?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a specific clothing item or accessory of mine that triggers your romantic thoughts instantly?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the most vulnerable question you could possibly ask me about how I view you?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'Have you ever felt like you had to protect me from a harsh truth about yourself or your past?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is a hidden romantic gesture you’ve wanted to do but were worried would be too cheesy or intense?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'What is the one thing about our connection that you think is completely irreplaceable?',
    type: 0,
    category: 4,
    level: 3,
  },
  {
    name: 'If you had to reveal the single deepest secret of your heart right now, what would the first sentence be?',
    type: 0,
    category: 4,
    level: 3,
  },
]
const dareBoyfriendSweet = [
  {
    name: 'Give your partner a 30-second tight bear hug.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Text your partner 'I love you' using only emojis.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner three genuine compliments right now.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Hold your partner's hand for the next three rounds of the game.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss on the forehead.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Slow dance with your partner for one minute, even if there is no music playing.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner your absolute favorite memory of the two of you.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a relaxing 2-minute shoulder massage.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner style your hair however they want and keep it that way for the next hour.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Look deeply into your partner's eyes for 30 seconds without blinking or laughing.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Sing a 15-second snippet of a romantic song to your partner.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Write a quick, cute sticky note love message and hide it in your partner's wallet or bag.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Whisper something sweet and romantic in your partner's ear.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner lean against you or rest their head on your lap for the next 15 minutes.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Recreate the exact face you make when you see your partner after a long day.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner the exact moment you realized you had strong feelings for them.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a gentle kiss on both cheeks and the tip of their nose.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner choose a nickname for you that you have to answer to for the rest of the day.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Show your partner the most wholesome, cute photo of them stored on your phone.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Put your arm around your partner and pull them close for the next two rounds.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'List five things you are incredibly grateful for regarding your partner.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Do your best impression of your partner being affectionate.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Send a sweet voice note to your partner right now saying why you appreciate them.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner sit on your lap for the next round of the game.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Draw a tiny heart on your partner's hand using a pen or marker.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner which of their physical features makes you smile the most.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a piggyback ride around the room.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Make a promise to your partner right now and vow to keep it.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner wear your favorite hoodie or jacket for the rest of the game.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Describe your partner using only three beautiful adjectives.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a 1-minute foot rub.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Take a cute, goofy selfie with your partner right now.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner what your dream vacation together would look like.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Kiss your partner's hand like a true old-school gentleman.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner a silly joke to try and make them laugh.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner choose one clothing item you have to wear tomorrow.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Share a habit of your partner's that you secretly find absolutely adorable.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Gently brush or run your fingers through your partner's hair for two minutes.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner what your favorite outfit of theirs is.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Write down a mini 'bucket list' item you want to achieve with your partner this year.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss on the wrist.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Make your partner a refreshing glass of water or their favorite drink right now.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner the first thing that goes through your mind when you wake up next to them.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Do a funny little happy dance just to make your partner smile.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner use your phone to post a cute photo of the two of you on your story.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner which movie couple reminds you the most of your relationship.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a warm kiss on the back of their neck.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Express your love for your partner in a fake, overly dramatic Shakespearean accent.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner draw a tiny smiley face on your ankle.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Tell your partner the sweetest dream you've ever had about them.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a gentle 2-minute hand massage.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Pinky swear to take your partner out on a surprise date sometime in the next two weeks.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner which song always makes you think of them.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Do your best impression of a suave movie character trying to win your partner over.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner tuck your shirt in or adjust your clothes to their liking.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner what you think their absolute greatest strength is.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a soft, lingering kiss on the cheek.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Serenade your partner for 20 seconds using an imaginary guitar.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner the exact moment you felt most proud to be their boyfriend.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner guide your hand to give them a comforting pat on the back.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Share a specific time your partner completely cheered you up when you were feeling down.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Keep eye contact with your partner while you both take a deep breath together.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner the best piece of advice they have ever given you.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a warm, comforting hug from behind.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner choose a phone wallpaper for you to keep for the next 24 hours.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Describe the perfect, ideal lazy Sunday morning spent with your partner.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Kiss your partner right on the tip of their chin.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner a specific personality trait of theirs that inspires you to be better.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Feed your partner a small bite of food or a sip of a drink like royalty.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Show your partner the very first text message exchange you can find in your chat history.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner what your absolute favorite date night with them has been so far.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a sweet, gentle kiss on the eyelids.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner adjust your posture and sit nicely next to them.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner what you think the two of you will look like when you are old and gray.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a playful, gentle boop on the nose.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Share a hidden talent or a tiny skill you have that your partner hasn't seen yet.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner lean their full weight against you for a solid minute.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner how your life has improved since the day you met them.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a soft, continuous head scratch for one minute.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Make a funny face at your partner and hold it until they crack a smile.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner which of their laughs or smiles is your absolute favorite.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner spray a tiny bit of their favorite perfume/cologne on you.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss right on their collarbone.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Tell your partner a secret childhood memory that you haven't shared with anyone else.",
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner put a cute hair clip or hair tie in your hair.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Share the specific physical sensation you get when you first see your partner after being apart.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a long, warm hug that lasts for a full 45 seconds.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner what scent reminds you most of them.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner hold your hand and trace the lines on your palm.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner a cute, fictional story starring the two of you as superheroes.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a soft, reassuring kiss on the temple.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Share the most romantic thought you had about your partner earlier today.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner lay their head on your chest and listen to your heartbeat for one minute.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner what you missed most about them the last time you were apart.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a gentle, playful squeeze on the arm.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner how much you appreciate the little things they do for you daily.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Let your partner draw a mini heart on your cheek with a piece of ice or a finger.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Tell your partner what your favorite season to spend with them is and why.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: 'Give your partner a gentle kiss on their knuckles.',
    type: 1,
    category: 4,
    level: 1,
  },
  {
    name: "Whisper 'You are my favorite person' into your partner's ear three times in a row.",
    type: 1,
    category: 4,
    level: 1,
  },
]
const dareBoyfriendMild = [
  {
    name: 'Let your partner scroll through your phone photos for 60 seconds without checking over their shoulder.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Do 20 push-ups right now while looking your partner directly in the eyes.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner read the last three text messages you sent to your best friend.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Imitate your partner's most common annoying habit and let them guess what it is.",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner apply a single coat of bright lipstick or lip gloss on you.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Speak in a formal British accent for the next three rounds of the game.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner look through your search history for the last 48 hours.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Do your absolute best impression of your partner's laugh.",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner give you a completely ridiculous makeover using items in the room.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Call a friend or family member and tell them a completely random, goofy fact, then hang up.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner tickle you for 15 seconds without you trying to block them.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Wear your socks on your hands for the next two rounds of the game.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner send a completely random, harmless emoji text to anyone in your contacts list.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Do your best impression of your partner when they are angry or frustrated.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner do your eyebrows using a brow pencil or gel.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Balance a cushion or pillow on your head for the next three rounds; if it falls, you lose a turn.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see the oldest selfie on your phone.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Sing the chorus of your favorite guilty-pleasure pop song at the top of your lungs.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner paint one of your fingernails a bright color.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to fit as many marshmallows or small snacks into your mouth as you safely can.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner view your screen time statistics on your phone right now.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Perform a dramatic 1-minute runway walk across the room like a high-fashion model.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner check your e-commerce cart or online shopping wish list.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Do your best impression of how your partner acts when they are sleepy.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner put a light smudge of makeup or lotion on the tip of your nose.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to do a headstand or a funny yoga pose chosen by your partner.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see your most embarrassing childhood photo on your phone or social media.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner choose an emoji that you must add to every text you send for the next 24 hours.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Attempt to do a dramatic belly dance for 30 seconds for your partner.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner check your saved posts or bookmarks on your favorite social media app.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Talk without closing your mouth for the next round of the game.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner order a random, cheap, funny item online using your account.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Do your absolute best impression of a dramatic soap opera character crying.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner rewrite your social media bio for the next 24 hours.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to spin around in circles 10 times and then walk a perfectly straight line across the room.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Let your partner check the 'Recently Deleted' folder in your photo gallery.",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Eat a slice of bread or a snack without using your hands at all.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner look at your alarms and see how many times you hit snooze.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Act like a dog or a cat begging for food for 30 seconds around your partner.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner choose a funny YouTube video or TikTok that you have to recreate right now.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Attempt to recite the alphabet backward as fast as you possibly can.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see the last thing you took a screenshot of on your phone.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Put a piece of ice down your shirt and keep it there until it completely melts.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Let your partner read a random note from your phone's Notes app.",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Do a dramatic lip-sync performance to a dramatic sad song chosen by your partner.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see your email inbox spam folder or unread count.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to make your partner laugh purely by making weird, silent facial expressions.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner pick your outfit for work, school, or the weekend tomorrow.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Keep a totally serious, straight face while your partner tries their best to make you laugh for 30 seconds.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner go through your wallet and ask questions about anything inside.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Do 15 jumping jacks while loudly shouting 'I love my partner!' with each jump.",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see your most recently used emojis list.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Give a passionate 1-minute speech about a completely boring object in the room.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner check your calendar or daily planner entries.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to balance an open bottle of water on the back of your hand for 30 seconds.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner text your sibling or friend a goofy joke from your phone.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Imitate a famous cartoon character of your partner's choice for the next two rounds.",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see your top artists or most played songs on your music streaming app.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner gently pinch your cheeks and hold them like a baby for 30 seconds.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see what apps you have currently open in the background of your phone.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Whisper everything you say for the next two rounds of the game.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see your food delivery app order history.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to draw a picture of your partner on a piece of paper using your non-dominant hand.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner check your blocked list on social media or your phone.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Allow your partner to trace a funny shape on your back with their finger, and you must guess what it is.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner look at your cloud storage or files app.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Stand in the corner of the room on one foot for the next round of the game.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner choose a random word that you have to say at the end of every sentence for 10 minutes.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to hold a funny, awkward stretch or pose for a full 60 seconds.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see your custom settings or shortcuts on your phone.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Do your best impression of your partner's parents or family members.",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner check your podcast or audiobook listening history.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Eat a spoonful of a condiment you don't particularly love (like mustard or hot sauce).",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see the list of accounts you follow on your favorite app.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Repeat everything your partner says for the next 60 seconds.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see your maps search history or recent destinations.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Pretend you are a flight attendant giving a safety briefing using items in the living room.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner check your notification center right now.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to juggle three small items chosen by your partner for at least 10 seconds.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see your app store download history.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Do your best impression of an aggressive infomercial salesman selling a basic item.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner check the names you have saved for people in your contacts list.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Sing a popular song but replace every single lyric with your partner's name.",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner look at the tabs you currently have open on your mobile browser.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Wear your shirt completely inside out for the remainder of the game.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see your custom playlists on your music app.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to balance a book on your nose for 15 seconds.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see the draft folder of your email or social media accounts.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Speak only in questions for the next two rounds of the game.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner check the privacy settings on your phone.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Do 10 slow, dramatic squats while maintaining intense eye contact with your partner.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Let your partner see your weather app's saved locations.",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to wink with both eyes alternating as fast as you can for 20 seconds.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner check your fitness or step-tracking app data for the week.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Act like a robot whose battery is slowly dying for 40 seconds.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: "Let your partner check your phone's storage breakdown to see what takes up the most space.",
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Try to wrap yourself completely up in a blanket like a burrito without using your hands.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner see your Bluetooth paired devices list.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Speak like a pirate for the next three turns of the game.',
    type: 1,
    category: 4,
    level: 2,
  },
  {
    name: 'Let your partner check the custom notification sounds you have set for them.',
    type: 1,
    category: 4,
    level: 2,
  },
]
const dareBoyfriendSpicy = [
  {
    name: 'Give your partner a passionate, breathless 10-second kiss right on the lips.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Whisper your absolute dirtiest or most scandalous fantasy into your partner's ear.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Take off one article of clothing of your partner's choice.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Trace your lips slowly along your partner's jawline down to their neck.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner give you a passionate hickey or love bite anywhere they choose.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Slowly blindfold yourself and let your partner touch you anywhere they want for one minute.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner an intense, deep 5-minute full-body massage.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Kiss your partner's neck passionately until they tell you to stop.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Take off your shirt and remain shirtless for the rest of the game.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Trace your fingers slowly under your partner's shirt along their bare back.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Sit completely on your partner's lap and look them in the eyes while breathing heavily for 1 minute.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a slow, teasing kiss on their inner thigh.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner place their hands underneath your shirt onto your bare chest or back.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Describe in explicit detail exactly what you want to do to your partner later tonight.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Nibble gently on your partner's earlobe for 30 seconds.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner slowly unbutton or unzip one item of your clothing.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Kiss your partner anywhere on their body *except* their face.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Sit on your partner's lap facing them, and gently grind or sway to an imaginary rhythm for 30 seconds.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Run your tongue slowly along your partner's collarbone.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner choose an article of clothing that you have to take off right now.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a slow, deep French kiss that lasts for at least 20 seconds.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Whisper a secret physical craving you have about your partner that you've never told them.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner trace their fingers along your inner thigh as high up as they want.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Seductively whisper your favorite physical attributes of your partner right against their neck.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Take your partner's hand and place it on any part of your body you want them to touch.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner blindfold you and feed you a snack or drink in a teasing way.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Kiss your partner's bare stomach slowly.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Show your partner your best, most provocative bedroom face.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Gently bite your partner's lower lip while kissing them.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner sit straddled on your lap for the next two rounds of the game.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Run your hands slowly all over your partner's body for one minute while closing your eyes.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Tell your partner exactly which outfit of theirs turns you on the absolute most.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a sensual kiss on their hip bone.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner remove your socks using only their teeth.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Describe the naughtiest dream you have ever had involving your partner.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Kiss your partner from their lips all the way down to their chest.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner whisper a dirty command in your ear that you have to obey right now.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Lick your lips seductively while looking at your partner's favorite asset.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner touch your bare waist or hips beneath your clothes for one minute.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Tell your partner the exact physical touch from them that drives you crazy.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a slow, intense kiss on the back of their knee or inner arm.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner completely choose how many clothes you have to leave on for the rest of the game.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Seductively take off your shoes and socks using a slow-motion routine.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Whisper what you want to do to your partner's body using an incredibly deep, sultry voice.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner put their hands in your back pockets while you give them a deep kiss.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Describe the wildest location where you would secretly love to hook up with your partner.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Gently pull your partner's hair slightly while kissing them passionately.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner trace a piece of ice down your bare chest or stomach.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Tell your partner a physical fantasy you've been too embarrassed or hesitant to bring up before.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a long, slow kiss on their belly button.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner run their cold hands underneath your shirt against your bare skin.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Describe what your partner looks like when they are at their most alluring or seductive.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Hold your partner by their waist, pull them flush against you, and hold them there for 1 minute.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner unbuckle your belt or loosen your pants/shorts.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a lingering kiss on the inside of their wrist.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Tell your partner what physical act you think about when you miss them intensely.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner bite your neck or shoulder gently.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Seductively whisper a list of things you want your partner to do to you later.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss while lifting them up or pressing them against a wall.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner explore your chest or back with their lips for 1 minute.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Describe your favorite memory of a time the two of you were physically intimate.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner slip their hand inside your shirt and leave it there for the next round.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Give your partner a teasing kiss on the corner of their mouth, but don't give them a full kiss yet.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Tell your partner what specific lingerie, underwear, or clothing style you want to see them in.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner tickle or touch your most sensitive, non-private spot for 30 seconds.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Slowly run your tongue along your partner's upper lip.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner sit on your back while you try to do three push-ups.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Describe the exact physical sensation you get when your partner kisses your neck.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner three slow, deep kisses on three different spots on their neck.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner choose one item of clothing to swap with you for the next three rounds.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Seductively slide your hand up your partner's shirt and leave it there.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Tell your partner what time of day you find yourself feeling the most physically attracted to them.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a soft, warm kiss on their collarbone and hold it for 5 seconds.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner put their feet in your lap and massage them sensually.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Whisper a naughty, three-word phrase into your partner's ear in a raspy voice.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner undo the top two buttons of your shirt using only one hand.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a deep kiss while running your fingers through their hair aggressively.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Tell your partner which part of their body you are secretly most obsessed with.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner lean you back and give you a lingering kiss from above.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Seductively slide your fingers along your partner's waistline.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Describe in rich detail the perfect, steamy night in with your partner.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner trail their fingers from your neck down to your belt line.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a firm, passionate squeeze on their backside.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Tell your partner what thought or look from them instantly gets you in the mood.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner trace their lips along your shoulder line.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Seductively blow a warm breath of air onto your partner's neck or ear.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss while keeping your eyes completely wide open.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Tell your partner the craziest thought you've ever had about them in public.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner put a blindfold on you and guess what part of your body they are kissing.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Slowly trace your finger along your partner's lower lip.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a slow, heavy-breathing hug where your chests are pressed tightly together.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Tell your partner a specific phrase or word that instantly makes you feel weak around them.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner run their fingers down the middle of your bare stomach.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss, then immediately pull away and make them wait for the next one.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Tell your partner what secret touch you've been wanting from them all day.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Let your partner lay on top of you for the next full round of the game.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Trace your lips gently along your partner's eyebrows down to their cheeks.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Tell your partner the most intense physical urge you've had to restrain yourself from doing around them.",
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: 'Give your partner a deep, passionate kiss that leaves both of you completely breathless.',
    type: 1,
    category: 4,
    level: 3,
  },
  {
    name: "Look your partner dead in the eye and say, 'You are completely mine tonight.'",
    type: 1,
    category: 4,
    level: 3,
  },
]

// ==================== Girlfriend ====================
const truthGirlfriendSweet = [
  {
    name: 'What was the exact moment you realized you had feelings for me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your absolute favorite memory of us together so far?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a small, everyday habit of mine that secretly makes you smile?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If we could teleport to any vacation spot in the world right now, where would you choose?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the sweetest thing I have ever done or said to you?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What song always reminds you of our relationship?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What was your first impression of me, and how has it changed?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite physical feature of mine?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If you had to describe our relationship in just three words, what would they be?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a dream or goal you have for us in the future?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What nickname of mine do you love the most, or wish you could call me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'When did you first feel completely comfortable being yourself around me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite outfit that I wear?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If our love story was a movie title, what would it be?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a hobby or activity you want us to try together next?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the best piece of relationship advice you’ve ever received?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What profile picture or photo of us together is your favorite?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'How do you feel when we are apart for a long time?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a small way I can show you I love you every day?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite way to cuddle or receive affection?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If you could relive one single day from our past, which day would it be?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a personality trait of mine that you hope never changes?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What makes you feel the most safe and secure when you are with me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the funniest inside joke we share?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a book, movie, or show that you desperately want me to watch with you?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'How do you think we balance each other out best?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite date night we’ve ever had?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is something I do that makes you feel incredibly proud to be my girlfriend?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If you could write a letter to your past self about our relationship, what would it say?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite scent or cologne/perfume that I wear?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a quirky thing about me that you find unexpectedly endearing?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If we were characters in a TV show, which couple would we be?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the most thoughtful gift you’ve ever received from anyone?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is something you love doing for me when I’m having a rough day?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite thing to do together when we are just staying at home?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a secret talent or skill you have that you haven’t fully shown me yet?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'When was a time you felt a massive rush of butterflies around me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: "What is your favorite childhood memory that you haven't told me yet?",
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a tradition you want us to start together?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the most romantic gesture you’ve ever seen in a movie that you’d love to experience?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'How has your perspective on love changed since we started dating?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite season of the year to spend time with me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is something you are looking forward to doing with me next month?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What text message from me did you secretly screenshot or save because it was so sweet?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite morning routine when we are together?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If you could pick one song for us to dance to right now, what would it be?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a food or meal that always reminds you of a special moment we shared?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is something you find incredibly cute about the way I talk or laugh?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the best compliment I have ever given you?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'How do you think meeting you has changed my life for the better?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite way to spend a rainy Sunday with me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a dream house feature you hope we can have together one day?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite memory of us with your friends or family?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: "What is something new you've learned about yourself since being with me?",
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite photo of me on your phone?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If you could wake up tomorrow with any new skill to benefit us, what would it be?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a tiny detail about me that you noticed on our very first date?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What makes you feel most appreciated in our day-to-day life?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite thing about how we say goodbye to each other?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: "What is a specific comfort food you'd love for us to cook together?",
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If you could describe my laugh in one word, what would it be?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your ultimate favorite way to wake up next to me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is something you think we are both exceptionally good at as a team?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the best part of waking up to a text from me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: "What is a place you’ve never been to that you only want to visit if it's with me?",
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a silly habit you hope we still have when we are 80 years old?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: "What is the most peaceful moment you've ever felt in my arms?",
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite piece of clothing of mine that you love to steal or wear?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a specific conversation we had that made you feel deeply connected to me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is something you are incredibly grateful for in our life right now?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If you had to pick a theme song for our future, what would it be?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: "What is a cute pet name you secretly wouldn't mind me calling you?",
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the most creative date idea you’ve been secretly wanting to pitch to me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite thing about the way I handle stressful situations?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a childhood dream of yours that you feel closer to achieving with me around?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite memory of our first anniversary or milestone together?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is something you love about the dynamic between us?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the best surprise I have ever pulled off for you?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a small gesture I do that instantly calms your anxiety down?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your absolute favorite thing to talk about when we lie awake at night?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a hidden passion of yours that you want to share more deeply with me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the most comforting thing I say to you when you are sad?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a specific goal you want to crush together by the end of this year?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite thing about my smile?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If we were to write a book together, what genre would it be?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a habit of mine that makes you realize how much I care about you?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite way to celebrate a special occasion with me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is something I do that makes you instantly feel loved, even without words?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a token or keepsake from our relationship that you treasure the most?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your favorite thing about how we handle differences or disagreements?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a dream vacation itinerary you have already planned for us in your head?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is something you love about my friends or family?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: "What is a nostalgic movie from your childhood you can't wait to watch with me?",
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is your absolute favorite type of kiss from me?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a character trait of mine that you hope our future kids (if any) inherit?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is the most meaningful conversation we’ve had so far?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: "What is your favorite thing about how we support each other's independence?",
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'What is a skill or hobby I have that you find absolutely mesmerizing to watch?',
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: "What is the sweetest thing you've ever overheard me say about you to someone else?",
    type: 0,
    category: 5,
    level: 1,
  },
  {
    name: 'If you could freeze time in any moment of our relationship, which moment would it be?',
    type: 0,
    category: 5,
    level: 1,
  },
]
const truthGirlfriendMild = [
  {
    name: 'What is a minor white lie you’ve told me to avoid hurting my feelings?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What did you actually think of my style the first time you met me?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever secretly checked my phone or social media notifications?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is my most annoying habit that you usually just ignore?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is something you accidentally ruined or spilled of mine but never confessed?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever pretended to like a food or meal I cooked just to be nice?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a silly reason you’ve gotten slightly jealous of someone around me?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a song or movie I love that you secretly think is absolutely terrible?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever stalked an ex of mine on social media?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing that has happened to you while we were together?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever pretended to be asleep just to avoid talking or getting out of bed?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a habit of mine that completely baffles or confuses you?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'If you could delete one item from my wardrobe permanently, what would it be?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is something I do that you think is a total waste of money?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever text your friends about a minor argument we were having?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is the longest you've gone without washing your favorite piece of loungewear?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a secret pet peeve you have about the way I text?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever faked being sick to get out of a social event or family gathering?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is your true opinion on my driving skills?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a silly superstition or irrational fear that you still hold onto?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "Have you ever hidden a purchase or receipt from me so I wouldn't see the price?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most useless piece of trivia you know by heart?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a funny misunderstanding we had early in our relationship?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "Have you ever laughed at a joke of mine that you didn't actually get?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the worst haircut or style choice you’ve ever committed to in the past?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What do your friends honestly think is my funniest or weirdest trait?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever re-gifted something I gave you, or thought about doing it?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is a reality TV show or guilty pleasure you watch that you're slightly embarrassed by?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is the pettiest reason you've ever gotten annoyed with me?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'If you had to change one minor rule in our relationship, what would it be?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "Have you ever snooped around my room or house when I wasn't looking?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most embarrassing nickname your parents used to call you?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever pretended to know about a topic I was talking about when you had no clue?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a habit of mine that you have subconsciously started doing yourself?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is the most ridiculous thing you've ever done because of a crush?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever looked at my horoscope or compared our zodiac signs secretly?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a food combination you absolutely love that everyone else thinks is gross?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What was your worst dating app experience before you met me?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever cleared your search history because you were embarrassed by a random Google search?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is something you think I am surprisingly bad at doing?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the weirdest dream you’ve ever had about me?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever deliberately taken a bad photo of me just because it made you laugh?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a secret talent you have that is completely useless but impressive?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most dramatic thing you did as a teenager?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever lied about being busy just to stay home and do absolutely nothing?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is your absolute biggest pet peeve when it comes to restaurant manners?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is something I do when I'm sleeping or waking up that cracks you up?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever stolen something small, like a pen from a bank or a piece of candy?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a song you love singing at the top of your lungs only when you are completely alone?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What do you think is my most unappealing or unphotogenic angle?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever pretended to like a sport, hobby, or video game just to impress a guy?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the longest you’ve ever gone without taking a shower?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a fashion trend happening right now that you secretly think looks ridiculous?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever accidentally sent a text about me *to* me?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is your absolute least favorite chore that you always try to pass off to me?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What was the most awkward phase of your life (middle school, high school, etc.)?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever lied to your parents about where you were going when you were younger?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most unromantic setting where you’ve ever felt an impulse to kiss me?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a movie that everyone loves but you secretly think is totally overrated?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever been caught talking or singing to yourself when you thought no one was looking?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most embarrassing thing you’ve ever posted on social media that you later deleted?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a habit of your friends that secretly annoys you the most?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "Have you ever eaten food off the floor past the 'five-second rule'?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most ridiculous lie you told a teacher to get out of trouble?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is something you completely misjudged about me when we first started talking?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "Have you ever avoided answering my call because you just weren't in the mood to talk?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is your go-to white lie when you are running late?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a cheesy pick-up line that would actually work on you if you were single?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever practiced an argument or conversation in the mirror before talking to me?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the weirdest item currently sitting in your purse or bag?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a purchase you made recently that you immediately regretted?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever cried during a commercial or a completely non-sad movie scene?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is the most chaotic or messy part of your daily routine that I don't see?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever stalked a complete stranger on social media just because you were bored?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most embarrassing text you’ve ever sent to the wrong person?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is an insecurity of yours that you think is completely irrational but can't help?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever pretended to love a gift I gave you when you actually wanted to return it?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a slang word or phrase people use today that you secretly despise?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is the longest you've ever spent getting ready for a date with me?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever lied to a waiter or cashier to get a discount or freebie?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is your ultimate comfort show that you can watch on loop forever?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a bad habit you have that you are actively trying to hide from my family?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever ghosted someone in the past, and why did you do it?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most ridiculous rumor you’ve ever heard about yourself?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is something you always forget to do, no matter how many times you're reminded?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "Have you ever snooped through a partner's room or belongings in a past relationship?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a silly celebrity crush you have right now that you know is totally unrealistic?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most embarrassing song on your current playlist?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever blamed a weird sound or bad smell on a pet or someone else when it was you?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a minor detail about our first date that you completely forgot until recently?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the most useless impulse buy sitting in your closet right now?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever lied about your age or a minor detail on your social media profiles?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is a habit of mine that makes you roll your eyes, even if you don't say anything?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is the most awkward conversation you've ever had to have with a boss or co-worker?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever kept a piece of clothing an ex gave you just because it was comfortable?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a food that you are absolutely terrified of trying?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: "What is the most ridiculous thing you've ever searched on Google out of pure curiosity?",
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'Have you ever pretended to be interested in a story I was telling when you completely zoned out?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is a habit of yours that you think would drive me crazy if we lived together?',
    type: 0,
    category: 5,
    level: 2,
  },
  {
    name: 'What is the funniest or most accurate impression you can do of me right now?',
    type: 0,
    category: 5,
    level: 2,
  },
]
const truthGirlfriendSpicy = [
  {
    name: 'What is your ultimate, wildest romantic fantasy that you haven’t told me yet?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What was your exact physical or romantic thought about me on our very first date?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a specific thing I do in the bedroom or during intimacy that drives you crazy?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is something you want to try in our intimate life but have been too shy to bring up?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever had a romantic or physical dream about someone else since we’ve been dating?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is your biggest fear or anxiety regarding the long-term future of our relationship?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a deep insecurity about your body or appearance that you rarely talk about?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever compared our physical connection or chemistry to a past relationship?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most daring or public place you have ever thought about getting intimate with me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a secret about your past romantic life that you were afraid would make me judge you?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'When was a time in our relationship you felt emotionally distant from me, and why?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a habit or trait of mine that makes you question our long-term compatibility?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most intense physical attraction you’ve ever felt toward me in a single moment?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt unappreciated or taken for granted by me recently?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a mistake or regret from a past relationship that taught you a harsh lesson?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What outfit or look of mine do you find most physically alluring or intoxicating?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever kept a secret from me because you were genuinely terrified of my reaction?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is your absolute biggest turn-on that completely catches you off guard?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a boundary of yours that you feel I have come close to crossing?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever faked or exaggerated your enthusiasm during intimacy with me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most physically sensitive part of your body that you love having touched?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a deep emotional regret you carry from your past that still affects you today?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt a sudden spark of attraction toward a mutual friend or coworker?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a specific piece of lingerie or clothing you’ve bought with the sole intention of teasing me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the biggest argument or disagreement we’ve had that you still don’t feel fully resolved about?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a secret vulnerability of yours that you try hardest to hide from the outside world?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever checked up on an ex-boyfriend out of genuine curiosity or lingering feelings?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a romantic gesture or physical act you secretly wish I did much more often?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most emotional or vulnerable you have ever felt while we were being intimate?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever doubted whether I am truly the right person for you?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a fantasy or scenario you’ve read about or watched that you want to recreate with me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is something about your family or upbringing that you are hesitant to fully share with me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt judged by me for a lifestyle choice or past action?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is your honest opinion on how well we communicate when we are angry?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "What is a physical feature of mine that you weren't sure about at first but now find incredibly attractive?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt suffocated or like you needed a lot of space from me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most adventurous thing you’ve ever done on a whim or a dare?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "What is a secret desire you have that you feel crosses into 'too taboo' to talk about?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "When was the last time you felt genuinely hurt by something I said or did but didn't bring up?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a part of your daily routine or life that you feel I try to control too much?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt like you had to change a core part of your personality to make this relationship work?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most intensely passionate kiss we’ve ever shared, in your memory?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is an assumption I make about you that is completely wrong?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt a wave of jealousy over how I interact with one of my friends?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a romantic truth you are currently holding back from me because the timing feels wrong?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is your biggest turn-off during an intimate or romantic moment?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt like I was comparing you to someone else, consciously or unconsciously?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most deeply personal secret you’ve shared with your best friend but not with me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a physical touch or gesture that instantly triggers an emotional response from you?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever stayed in a past relationship way longer than you should have, and why?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a specific habit of mine that completely kills the romantic mood for you?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most emotional heartbreak you’ve ever experienced before you met me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt like you were putting more effort into our relationship than I was?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a physical fantasy you’ve had about me while we were apart or long-distance?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is something you think I am too sensitive or defensive about?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever had a gut feeling or intuition about us that scared you?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a part of your past that you wish you could completely erase or undo?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most attractive quality a person can possess that you think I have in spades?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "Have you ever felt like my friends or family don't fully accept or like you?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "What is a raw, uncensored truth about your current mental health or emotional state that you haven't shared?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most reckless thing you’ve ever done for love or passion?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt physically insecure while being intimate with me, and how can I help?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "What is a specific question about my past that you've been dying to ask but are afraid of the answer?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is your honest evaluation of our financial compatibility for the future?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt like a priority shifted in my life away from you?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a sensory detail (a scent, a sound, a view) that instantly makes you think of our intimate moments?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a piece of advice your parents gave you about relationships that you secretly fear might be true about us?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt like you had to hide your success or achievements to protect my ego?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "What is the most intense dream you've ever had that left you feeling confused the next day?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a flaw of mine that you find hardest to accept or live with?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt like we were rushing into things, or conversely, moving way too slow?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a specific phrase or word I can say during intimacy that completely elevates the experience for you?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a truth about your past heartbreaks that makes it hard for you to fully trust people now?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "Have you ever felt like I don't truly listen to you when you are venting or upset?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most challenging obstacle you think we will have to overcome as a couple?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "Have you ever felt tempted to cheat or stray in a past relationship, even if you didn't do it?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a hidden expectation you have of me that you haven’t explicitly stated?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most intensely vulnerable thing I could do right now to make you feel closer to me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt like our relationship lacks a certain type of excitement or spontaneity?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is your biggest fear about growing old or long-term aging within a relationship?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a specific habit of mine that makes you feel incredibly disconnected from me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever had a crush on a fictional character or celebrity that felt strangely intense?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is your honest opinion on how we handle physical space and independence?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most passionate or romantic environment you can possibly imagine for us?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt like I put my career, hobbies, or friends above your emotional needs?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "What is a deep personal goal you have that you're worried our relationship might hinder?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "What is the most intense emotional reaction you've ever had to a small gesture I made?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt like you were living in the shadow of my past relationships or achievements?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "What is a physical boundaries rule you have for yourself that you haven't explicitly shared with me?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most raw, honest feedback you could give me about my kissing style?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "Have you ever felt like I don't fully understand or appreciate your love language?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a secret anxiety you have about how your friends or family perceive our relationship?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most thrilling risk you would be willing to take with me right now?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'Have you ever felt a momentary wave of regret immediately after a major relationship milestone with me?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a specific way you wish I would support you emotionally when you are stressed?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most intimate, non-physical connection you feel we share?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: "Have you ever hidden an aspect of your true personality because you worried I wouldn't find it attractive?",
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is a specific question you want me to answer with absolute, unfiltered honesty right now?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'What is the most rewarding part of pushing through our most difficult relationship moments?',
    type: 0,
    category: 5,
    level: 3,
  },
  {
    name: 'If you could ask a crystal ball one ultimate truth about our future together, what would you ask?',
    type: 0,
    category: 5,
    level: 3,
  },
]
const dareGirlfriendSweet = [
  {
    name: 'Give your partner a 30-second back rub.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Look into your partner's eyes and list three things you love about their personality.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Slow dance with your partner for one minute without any music playing.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss on the forehead.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Hold your partner's hand for the next three rounds of the game.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Write a quick, cute love note on a piece of paper and hand it to them.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Serenade your partner with a chorus of your favorite love song, even if you sing out of tune.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a genuine, warm hug that lasts for at least 15 seconds.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner your absolute favorite memory of when you two first started dating.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner rest their head in your lap for the next ten minutes.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Whisper something genuinely sweet and loving into your partner's ear.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a gentle kiss on both cheeks.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Make a silly face at your partner and try to make them laugh without making a sound.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner a hidden talent you have that they might not know about yet.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Compliment your partner on an attribute of theirs that doesn't involve their physical appearance.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Do a quick, playful 10-second runway walk across the room just for them.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Trace your finger gently along your partner's palm or arm.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Recreate your favorite photo of the two of you right now.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner choose a cute nickname for you that you have to use for the rest of the day.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner what first attracted you to them when you met.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a gentle, relaxing head massage for two minutes.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Share a dream or future goal you have that involves your partner.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a soft, loving kiss on the hand like royalty.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner which of their habits always makes you smile.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Wink at your partner across the room every time you make eye contact for the next 15 minutes.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner wrap you up in a blanket like a burrito.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Say 'I love you' in the most dramatic, theatrical voice you can manage.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Lean your head on your partner's shoulder for the next two rounds.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Show your partner the most adorable photo of yourself as a child.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Describe your partner using only three words, making sure they are all incredibly positive.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Play with your partner's hair gently for the next 60 seconds.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner which romantic movie character they remind you of the most.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a high-five, then immediately turn it into a sweet hand interlock.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Share the specific moment you realized you had strong feelings for them.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Draw a tiny heart on your partner's hand using a pen or just your finger.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss on the tip of their nose.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner a song that always makes you think of them.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner tickle you for exactly 5 seconds without you trying to run away.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Praise your partner for something wonderful they did during the past week.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Look your partner in the eyes and tell them they are your favorite person.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Put your arms around your partner's neck and hold them close for a moment.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner about a time they made you feel incredibly safe and cared for.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Make a pinky promise to your partner to do something nice for them tomorrow.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Take a cute, goofy selfie together right now and save it.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner the best piece of advice they have ever given you.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss on the chin.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner what your perfect, ideal date night with them would look like.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner take a photo of you smiling genuinely.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Gently rest your head against your partner's chest and listen to their heartbeat for 30 seconds.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Share a specific inside joke between the two of you that always cracks you up.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a sweet compliment about their smile.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Hold your partner's face gently in your hands for 10 seconds while smiling at them.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner your favorite thing about how they dress or style themselves.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Squeeze your partner's hand firmly three times as a silent code for 'I love you.'",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner the funniest thing that has ever happened to the two of you together.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Do a silly little happy dance to show how glad you are to be with them.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss on the wrist.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner a character trait of theirs that you wish you had more of yourself.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner choose one clothing accessory for you to wear for the rest of the game.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner what you think their absolute greatest strength is.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a long, warm embrace from behind while they are sitting or standing.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Describe the very first impression you had of your partner in vivid detail.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner style your hair into a cute or funny look using a single clip or tie.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Tell your partner what you look forward to the most when you know you're about to see them.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a quick, gentle shoulder squeeze to show your appreciation.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Share the best compliment your partner has ever given you and why it stuck with you.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Make a tiny paper airplane or origami shape and give it to your partner as a token.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner a specific small habit of theirs that you secretly find adorable.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Kiss your partner's cheek while making a loud, comedic kissing sound.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner how they make your life brighter or easier on a daily basis.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner whisper a sweet secret into your ear.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Draw a funny, cute little stick-figure drawing of the two of you on a scrap of paper.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner which season of the year reminds you of them the most and why.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a light, comforting back scratch for one minute.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner what your favorite physical feature of theirs is, keeping it totally sweet.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Put a sweet, romantic wallpaper on your phone background for the next 24 hours.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner how much you appreciate the way they listen to you.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Blow your partner a sweet, dramatic kiss from across the room.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner about a specific time they made you laugh until your stomach hurt.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Hold your partner's hand and walk around the room together once like royalty.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner which of their favorite hobbies you enjoy learning about the most.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Give your partner a warm, tight hug and don't let go until they release you first.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner a dream you had about them recently, or make up a cute one.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner choose a favorite song for the two of you to listen to together right now.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner a specific way they inspire you to be a better person.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a sweet, tender kiss on their shoulder.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Tell your partner the most romantic thing you think you've ever done for each other.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: "Make eye contact with your partner and don't look away or blink for 20 seconds.",
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner a food or meal that always reminds you of a great time you shared.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a gentle, reassuring squeeze of the arm.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner how they managed to win your heart completely.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner give you a piggyback ride across the room, or vice versa if preferred.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner a specific goal you want to achieve together in the next year.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a loving kiss right on the jawline.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner why you feel incredibly lucky to have them in your life.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Let your partner rest their feet on your lap for the next round of the game.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner your absolute favorite thing about their laugh.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Give your partner a sweet kiss on their collarbone.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'Tell your partner how glad you are that they are a part of your world.',
    type: 1,
    category: 5,
    level: 1,
  },
  {
    name: 'End the round by giving your partner a huge smile and a sweet kiss on the lips.',
    type: 1,
    category: 5,
    level: 1,
  },
]
const dareGirlfriendMild = [
  {
    name: 'Let your partner look through your recent camera roll for one full minute.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Speak in a posh British accent for the next three rounds of the game.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner style your hair however they want, and you must leave it until the game ends.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Send a random, slightly confusing text to a close friend and show your partner their reaction.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: "Wear your partner's socks over your hands for the next two rounds.",
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner post a goofy photo of you on your social media story right now.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Allow your partner to read the last three text messages you sent to your best friend.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: "Do your best, most dramatic impression of your partner's most common phrase or habit.",
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner do your makeup using only three items, with no mirror allowed until they finish.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Trade shirts with your partner for the next three rounds of the game.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner scroll through your search history for 30 seconds.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: "Call a random contact on your phone and sing them 'Happy Birthday' even if it isn't their birthday.",
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Try to balance an object chosen by your partner on your head for one full minute without dropping it.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner send a completely safe but silly emoji-only text to anyone in your contacts.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Do 15 jumping jacks while loudly declaring your deep love for a random vegetable.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner read a random note from the notes app on your phone.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Attempt to do a cartwheel or a funny, exaggerated interpretive dance across the room.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner tickle your feet for 10 seconds while you try to keep a straight face.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Talk without closing your mouth for the next two minutes.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner re-dress you using items from their own closet for the rest of the game.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Do your absolute best impression of a famous celebrity and let your partner guess who it is.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner look at your screen time analytics on your phone.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Eat a spoonful of a condiment chosen by your partner (like ketchup, mustard, or hot sauce).',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner choose a silly filter on your phone and take a picture of you with it.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: "Talk in the third person for the next three rounds of the game (e.g., 'Sarah thinks that...').",
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner see the oldest photo currently stored on your phone.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Attempt to juggle three small items chosen by your partner for at least 10 seconds.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner check your most frequently used emojis list.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Do your best impression of a crying baby for 15 seconds.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner look through your online shopping cart or wishlist.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Try to touch your tongue to your nose, or do your best weird body trick.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner read the last text message you received from a family member.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Put on a blindfold and let your partner feed you a mystery snack from the kitchen.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner write a silly word on your arm with a washable marker.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Speak only in whispers for the next two rounds of the game.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: "Let your partner see your music app's most played or recently played songs.",
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Do 10 squats while holding a conversation with your partner without pausing.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner send a nice, appreciative text to your mom or dad from your phone.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Rhyme every single sentence you say for the next two minutes.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner inspect your purse, wallet, or backpack completely.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Perform a dramatic 30-second solo acting scene about losing a sock.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner change your contact name in their phone to something ridiculous.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Try to go 60 seconds without blinking while staring at a wall.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner see your most recent food delivery order history.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: "Act like a cat for one full minute—purr, stretch, and sit on your partner's lap.",
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner see who your top best friends or most recent chats are on social media.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Try to say a complex tongue twister five times fast without messing up.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner check your email inbox for any unread or funny marketing emails.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Spin around in a circle five times, then try to walk a straight line across the room.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner choose a YouTube video that you have to watch together right now.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Walk backwards everywhere you go for the next five minutes.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner look through your saved posts or bookmarks on social media.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: "Imitate your partner's laugh perfectly until they tell you to stop.",
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner draw a tiny, funny face on one of your fingernails.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Hold a spoonful of water in your mouth while your partner tries to make you laugh.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner choose a song, and you must lip-sync to it with maximum drama.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Pretend to be a tour guide and give your partner a detailed tour of the room you are in.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner inspect your vanity, makeup bag, or skincare shelf.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Quack like a duck every time you want to speak for the next round.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner see your calendar or planner for the upcoming week.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Do your best runway model walk while wearing a ridiculous item of clothing.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner read a random text from your group chat.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Keep your hands on your hips for the next three rounds of the game.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner pick a funny outfit for you to wear tomorrow.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Balance on one foot for the next two turns of the game.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner see your blocked list on your phone or social media.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: "Reenact a famous commercial or meme for your partner's entertainment.",
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner choose an item from the kitchen that you must smell while blindfolded.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Make up a 30-second rap or poem about the object directly to your left.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: "Let your partner look at your web browser's open tabs.",
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Pretend to be a robot until it is your turn again.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner see your top played video games or app usage stats.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Try to make your partner laugh within 30 seconds using only your facial expressions.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner choose a safe but funny nickname for you for the next week.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Give a passionate 1-minute speech about why your favorite food is the best thing ever.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner see the last thing you copied to your clipboard.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Stand up and do a silly, over-the-top opera high note.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner look through your alarm clock settings and times.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Pretend you are an anchor delivering a breaking news report about your current game.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner pick a funny photo of you to set as their lock screen.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Keep a totally serious, unsmiling face for the next two minutes while your partner jokes around.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner choose a random book page for you to read aloud in a dramatic voice.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Imitate a monkey or another funny animal for 20 seconds.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner see your email spam folder to look for funny subject lines.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Drink a full glass of water without using your hands at all.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner choose which ringtone your phone should have for the rest of the day.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Do your best impression of a flight attendant giving safety instructions.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: "Let your partner check your app store's recently downloaded or updated apps list.",
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Try to spell your full name backward out loud without making any mistakes.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner see your custom photo albums or hidden photos folder (if applicable).',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Pretend you are an infomercial host trying to sell a plain pen to your partner.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner choose a random filter on your camera and take a silly video of you.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Speak only in questions for the next two rounds of the game.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner see your navigation or maps search history.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Try to whistle a popular tune and make your partner guess what it is.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner check your podcast subscriptions or audiobooks list.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Walk around the room like a penguin for one full minute.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner choose a random word that you cannot say for the rest of the game.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Do a funny celebratory dance as if you just won a massive lottery jackpot.',
    type: 1,
    category: 5,
    level: 2,
  },
  {
    name: 'Let your partner take a goofy photo of you and send it strictly to your own best friend.',
    type: 1,
    category: 5,
    level: 2,
  },
]
const dareGirlfriendSpicy = [
  {
    name: 'Give your partner a passionate, breathless kiss that lasts for at least 10 seconds.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Whisper your absolute wildest, most scandalous fantasy into your partner's ear.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner give you a slow, intense kiss on your neck.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Feed your partner a snack or a piece of fruit using only your mouth.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Sit on your partner's lap for the next three rounds of the game.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a slow, sensual massage on their shoulders and neck for two minutes.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Take off one non-essential item of clothing of your partner's choosing.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Trace your lips along your partner's jawline without actually kissing them.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a seductive look and show them your best smoldering face.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner choose an item of clothing for you to remove.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Whisper a detailed, spicy confession about what you want to do later into their ear.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a playful bite on their earlobe or shoulder.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Let your partner's hands stay resting on your hips for the next two rounds.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Kiss your partner starting from their forehead, moving down to their lips, and ending on their neck.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Blindfold your partner and give them three light, mysterious kisses anywhere you choose.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner run their fingers slowly through your hair while looking deep into your eyes.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Seductively whisper a phrase in a foreign language (or fake it) into your partner's ear.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a long, passionate kiss on the lips while holding their waist tightly.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner trace a finger down your spine or across your bare arm.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Describe exactly what your partner could do right now to turn you on instantly.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner choose where they want to receive a passionate kiss from you.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Sit straddling your partner's lap for one full round of the game.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Slowly unbutton or unzip one item of your partner's clothing.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a deep, lingering kiss that leaves both of you wanting more.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner breathe softly against your neck for 10 seconds.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Tell your partner a specific physical spot on your body that is incredibly sensitive.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a dynamic, playful lap dance for 30 seconds without any music.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner kiss you anywhere they want for 15 seconds.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Whisper a naughty, playful secret that you have never told anyone else before.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Take your partner's hand and guide it to a spot on your body where you want to be touched.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a soft, slow trail of kisses along their collarbone.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner blindfold you for the next two rounds of the game.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Look your partner dead in the eye and tell them exactly how much you crave them.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner kiss your inner wrist or the palm of your hand sensually.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Take off your socks using only your feet or your teeth.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner slide their hand under your shirt and rest it on your bare skin for a minute.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a gentle, teasing kiss on the corner of their mouth.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Describe your favorite intimate or physical memory of the two of you in vivid detail.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner gently trail their fingers along your inner thigh.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss while pulling them as close to you as possible.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner hold your hands tightly above your head for 30 seconds.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Tell your partner what specific item of clothing they wear that makes you find them irresistible.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a slow, intense kiss on their lower back or hip.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner undo your hair or run their hands through it intensely.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Whisper a spicy question about their desires that you've been too shy to ask until now.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a light, teasing tickle that transitions into a passionate hug.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner kiss you on the lips while you keep your eyes completely closed.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Describe what your absolute dream intimate scenario with your partner looks like.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner nibble gently on your finger or hand.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a long, intense hug from behind, pressing your body close to theirs.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner whisper their dirtiest thought about you into your ear.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner three quick kisses on the neck followed by a deep kiss on the lips.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner choose whether you should whisper something sweet or something dirty.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Show your partner the exact piece of clothing or outfit that makes you feel the sexiest.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a firm, playful squeeze on their backside.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner trail a piece of ice or a warm finger across your neck or collarbone.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Tell your partner the exact time and place where you feel the most attracted to them.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a lingering kiss on their chest or near their heart.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner gently pull you into their lap and hold you there tightly.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Describe a time you had a vivid, spicy dream about your partner.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a soft kiss on their eyelids or closed eyes.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner touch your bare waist with warm hands for one full minute.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Look into your partner's eyes and gently bite your own lip seductively.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss that lasts until someone loses their breath.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner trace the outline of your lips with their index finger.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Tell your partner what physical feature of theirs completely drives you crazy.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a gentle, slow kiss on the inside of their elbow or wrist.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner choose one safe, romantic boundary to push or challenge right now.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Whisper an incredibly bold, confident compliment about your partner's physical appeal.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss while running your hands through their hair.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner rest their head on your chest while you stroke their back sensually.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Tell your partner what specific touch or gesture of theirs always gives you goosebumps.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a slow, deliberate trail of kisses down their arm.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner whisper a spicy command that you must follow for the next round.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Look at your partner intensely and blow them a slow, deliberate, seductive kiss.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a firm, passionate hug while lifting your feet slightly off the ground.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner kiss the back of your neck while you look away.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Tell your partner about a secret turn-on of yours that you haven't brought up before.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a playful, gentle tug on their shirt to pull them in for a quick kiss.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner trace a finger gently around your belly button.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Describe the exact physical sensations you feel whenever your partner kisses you deeply.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a soft, slow kiss on their temple, moving down to their jaw.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner choose a song to play in the background while you hold each other close.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Tell your partner a spicy thought you had about them earlier today.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a passionate kiss, then pull away slowly to look at their reaction.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Let your partner's hand rest gently on your inner thigh for the next round.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Whisper an intimate promise of something special you will do for them later tonight.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a light, teasing bite on their bottom lip during a kiss.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner pull you close by your belt loops or your waist.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Tell your partner what your favorite part of their bare body is to look at.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a deep kiss on the cheek that finishes near their ear.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner gently whisper your full name in a low, intense tone.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: "Trace your fingers along your partner's lips while looking into their eyes.",
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a long, slow kiss that focuses entirely on sensuality over speed.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner hold you in a full body embrace for 60 seconds without moving.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Tell your partner how much they excite you compared to anyone else in the world.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Give your partner a warm kiss on their shoulder blade or upper back.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Let your partner gently slide their hands down your sides from your arms to your hips.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'Tell your partner what you think the sexiest quality about them is.',
    type: 1,
    category: 5,
    level: 3,
  },
  {
    name: 'End the game by pulling your partner into a passionate, memorable kiss on the lips.',
    type: 1,
    category: 5,
    level: 3,
  },
]

const truthQuestions = [
  ...truthFriendsSweet,
  ...truthFriendsMild,
  ...truthFriendsSpicy,
  ...truthKidsSweet,
  ...truthKidsMild,
  ...truthKidsSpicy,
  ...truthFamilySweet,
  ...truthFamilyMild,
  ...truthFamilySpicy,
  ...truthCouplesSweet,
  ...truthCouplesMild,
  ...truthCouplesSpicy,
  ...truthBoyfriendSweet,
  ...truthBoyfriendMild,
  ...truthBoyfriendSpicy,
  ...truthGirlfriendSweet,
  ...truthGirlfriendMild,
  ...truthGirlfriendSpicy,
]

const dareQuestions = [
  ...dareFriendsSweet,
  ...dareFriendsMild,
  ...dareFriendsSpicy,
  ...dareKidsSweet,
  ...dareKidsMild,
  ...dareKidsSpicy,
  ...dareFamilySweet,
  ...dareFamilyMild,
  ...dareFamilySpicy,
  ...dareCouplesSweet,
  ...dareCouplesMild,
  ...dareCouplesSpicy,
  ...dareBoyfriendSweet,
  ...dareBoyfriendMild,
  ...dareBoyfriendSpicy,
  ...dareGirlfriendSweet,
  ...dareGirlfriendMild,
  ...dareGirlfriendSpicy,
]

export const allQuestions = [...truthQuestions, ...dareQuestions]

export const TypeList = {
  AllQuestions: allQuestions,
  Truth: truthQuestions,
  Dare: dareQuestions,
}
